// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:38:32.837Z
// Property: Laurel Heights at Cityview (ID: 5753165609697280)
// Collections: 19 amenities, 8 floorplans (live), 19 photos, 84 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5753165609697280",
  "property_external_id": "4520334",
  "property_zillow_url": "https://www.zillow.com/homedetails/5701-Overton-Ridge-Blvd-Fort-Worth-TX-76132/2060800000_zpid/",
  "property_apartments_url": "https://www.apartments.com/laurel-heights-at-cityview-fort-worth-tx/8rpvxf0",
  "property_google_business_url": "https://www.google.com/maps/place/Laurel+Heights+at+Cityview/@32.674744,-97.4144794,15z/data=!4m5!3m4!1s0x0:0x7f458c048f9aa9fc!8m2!3d32.6746781!4d-97.4144799",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443872084",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "laurel-heights-at-cityview",
  "property_name": "Laurel Heights at Cityview",
  "property_website_url": "https://www.laurelheightsapts.com/",
  "property_domain": "https://www.laurelheightsapts.com/",
  "property_address": "5701 Overton Ridge Blvd",
  "property_full_address": "5701 Overton Ridge Blvd, Fort Worth, TX 76132",
  "property_address_1": "5701 Overton Ridge Blvd",
  "property_address_2": null,
  "property_address_city": "Fort Worth",
  "property_address_state": "TX",
  "property_address_zip_full": "76132-3221",
  "property_address_zip": "76132",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "Benbrook",
  "property_address_latitude": "32.674744",
  "property_address_longitude": "-97.41447939999999",
  "property_email": "laurelheights@alapts.com",
  "property_phone": "(817) 346-6098",
  "property_call_tracking_phone": "817-767-1897",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Southwest Fort Worth comfort, Cityview convenience.</strong> Laurel Heights at Cityview pairs polished one and two bedroom apartments with open-concept kitchens, granite countertops, walk-in closets, and private outdoor space—plus resort-style community perks. <a href=\"/schedule-a-tour\">Schedule a tour</a> today.</p>",
  "property_long_description": "<p><strong>Southwest Fort Worth living with Cityview convenience.</strong> At Laurel Heights at Cityview, you’re close to the everyday essentials and the best of the Benbrook-area lifestyle, from Cityview Centre and Hulen Mall to dining, shopping, and entertainment at The Shops at Clearfork. Easy access to I-20, I-820, and Chisholm Trail Parkway keeps Fort Worth favorites, the Clearfork Trailhead, and Trinity Trails within reach.</p><p>Inside the community, choose from <a href=\"/floor-plans\">one and two bedroom apartments</a> designed with open-concept kitchens, granite countertops, stainless steel appliances, generous walk-in closets, in-home washer and dryer sets, and private patios or balconies. Beyond your front door, <a href=\"/amenities\">resort-style amenities</a> bring more to the day: a pool with sundeck, fitness center, tennis court, clubhouse, outdoor kitchen and grilling areas, package lockers, gated access, covered parking, valet trash, and online resident services. Pets have space to enjoy it too, with a bark park and posh pet spa built right into the community.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019d02f3-4a06-75ab-be6a-802fb2ffc6a1.webp",
  "property_featured_image_media": {
    "alt_text": "Gym with cardio machines, free weights, and weight machines.",
    "public_id": "019d02f3-4a06-75ab-be6a-802fb2ffc6a1",
    "storage_key": "property/5753165609697280/019d02f3-4a06-75ab-be6a-802fb2ffc6a1.webp",
    "width": 1233,
    "height": 844
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "440",
  "property_year_built": "1986",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.54545454545455",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://7850094.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://laurelheightsatcityview.loftliving.com/login",
  "property_apply_now_url": "https://7850094.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e6fc7-392e-7792-9e4f-402dc9384ba2.webp",
  "property_primary_logo_media": {
    "alt_text": "Laurel Heights at Cityview Premier Apartments logo",
    "public_id": "019e6fc7-392e-7792-9e4f-402dc9384ba2",
    "storage_key": "property/5753165609697280/019e6fc7-392e-7792-9e4f-402dc9384ba2.webp",
    "width": 1406,
    "height": 466
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e6fc7-38c5-70a7-ae61-cb47deb3317c.webp",
  "property_secondary_logo_media": {
    "alt_text": "Laurel Heights at Cityview logo",
    "public_id": "019e6fc7-38c5-70a7-ae61-cb47deb3317c",
    "storage_key": "property/5753165609697280/019e6fc7-38c5-70a7-ae61-cb47deb3317c.webp",
    "width": 1622,
    "height": 539
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e6fc7-38f1-7629-b3b6-2a5e628c16cb.webp",
  "property_icon_media": {
    "alt_text": "Laurel Heights at Cityview logo",
    "public_id": "019e6fc7-38f1-7629-b3b6-2a5e628c16cb",
    "storage_key": "property/5753165609697280/019e6fc7-38f1-7629-b3b6-2a5e628c16cb.webp",
    "width": 1091,
    "height": 1091
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e6fc7-38f1-7629-b3b6-2a5e628c16cb.webp",
  "property_fav_icon_media": {
    "alt_text": "Laurel Heights at Cityview logo",
    "public_id": "019e6fc7-38f1-7629-b3b6-2a5e628c16cb",
    "storage_key": "property/5753165609697280/019e6fc7-38f1-7629-b3b6-2a5e628c16cb.webp",
    "width": 1091,
    "height": 1091
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f42e3-6c44-702f-8c48-fc2b4e6a2fa8.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f42e3-6c44-702f-8c48-fc2b4e6a2fa8",
    "storage_key": "property/5753165609697280/019f42e3-6c44-702f-8c48-fc2b4e6a2fa8.webp",
    "width": 1280,
    "height": 424
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f42e3-5f79-7128-ba46-7247de41fd85.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f42e3-5f79-7128-ba46-7247de41fd85",
    "storage_key": "property/5753165609697280/019f42e3-5f79-7128-ba46-7247de41fd85.webp",
    "width": 1280,
    "height": 424
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#de5f32",
  "property_secondary_color": "#1d5b7d",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#4b4d51",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "550 - 1040",
  "property_sqft_min": "550",
  "property_sqft_max": "1040",
  "property_price_range": "1014 - 1612.33",
  "property_price_min": "1014",
  "property_price_max": "1612.33",
  "property_available_units": 24,
  "property_facebook_url": "https://www.facebook.com/LaurelHeightsAtCityview",
  "property_instagram_url": "https://www.instagram.com/laurelheightsapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJob550mBtToYR_KmajwSMRX8",
  "property_youtube_url": "https://www.youtube.com/channel/UCrq9AjJPhCekGDUGVhb2PJw",
  "property_yelp_url": "https://www.yelp.com/biz/heights-of-cityview-fort-worth-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Polished perks, easy everyday flow.</strong> At Laurel Heights at Cityview, amenities bring more to the routine—think a resort-style pool with sundeck, clubhouse coffee moments, a fitness center, tennis court, grilling stations, package lockers, covered parking, and valet trash. Inside, granite countertops, stainless steel appliances, faux wood flooring, in-home washer and dryer sets, walk-in closets, and a private patio or balcony add comfort where it counts.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans that work beautifully day to day.</strong> Choose from one and two bedroom apartments at Laurel Heights at Cityview, with open-concept kitchens, pantries, granite countertops, stainless steel appliances, in-home washer and dryer sets, and generous walk-in closets.</p><p>Select layouts add fireplaces, vaulted ceilings, or a private patio or balcony for extra character. Compare featured homes, then explore the full collection to find the space, timing, and details that fit.</p>",
  "property_home_gallery_blurb": "<p><strong>See Laurel Heights at Cityview in focus.</strong> Preview polished interiors with dark cabinetry, granite countertops, stainless steel appliances, wood-style flooring, fireplaces, and large windows. Then step outside through the photos to sunlit pool decks, a rock-waterfall backdrop, grilling spaces, courtyard seating, and pet-friendly green areas—all offering a quick look at apartment living in Fort Worth.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Southwest Fort Worth, mapped your way.</strong> From Laurel Heights at Cityview, quick coffee runs, Bryant Irvin errands, and Cityview Centre shopping stay close, while Clearfork brings open-air dining, movies, and riverfront energy just up the road. I-20 and Chisholm Trail Parkway make it easy to reach Benbrook Lake, TCU, the Cultural District, and downtown Fort Worth.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say it best.</strong> Laurel Heights at Cityview earns praise for its well-kept grounds, responsive maintenance, and friendly office team. Reviews also highlight roomy apartments, clean pools, updated spaces, and everyday convenience that keeps life moving with ease. See what stands out, then schedule a tour to experience the community for yourself.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day from a Southwest Fort Worth sweet spot.</strong> Around Laurel Heights at Cityview, the neighborhood feels practical without being plain: morning coffee and quick errands line the Bryant Irvin and Overton Ridge corridor, while Cityview Centre keeps everyday shopping close. When you want a bigger outing, head north to Clearfork’s open-air dining, cinema, and riverfront scene, or point west for Benbrook Lake, Candleridge Park’s French Lake trails, and wide-open time outside. I-20 and Chisholm Trail Parkway help you move between the Benbrook area, TCU/University, the Cultural District, and downtown Fort Worth with fewer detours. Use the map below to explore what’s nearby, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that add ease, energy, and a little extra polish.</strong> At Laurel Heights at Cityview, your day can move from coffee in the clubhouse to a workout in the fitness center, a match on the tennis court, or downtime by the resort-style pool and sundeck. Outdoor grilling stations, picnic space, controlled access gates, package lockers, covered parking, valet trash, and 24/7 online resident services keep the community experience simple and well connected.</p><p>Inside your apartment, open-concept kitchens with pantries, granite countertops, stainless steel appliances, faux wood flooring, in-home washer and dryer sets, generous walk-in closets, and a private patio or balcony bring comfort into the details. Plus, <a href=\"/pet-policy\">pet-friendly perks</a> like the bark park and posh pet spa make four-legged routines easier, too. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Laurel Heights at Cityview.</strong> Choose a one or two bedroom apartment with open-concept kitchens, granite countertops, stainless steel appliances, walk-in closets, in-home washer and dryer sets, and a private patio or balcony—all in a Southwest Fort Worth community with everyday convenience close by.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Connect with the Laurel Heights at Cityview leasing team for help with apartment availability, touring details, and finding your way to our Southwest Fort Worth community near everyday conveniences and major roadways.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Laurel Heights at Cityview?</strong> You’re in the right place. Find quick answers about leasing, apartment features, community amenities, pets, and everyday living in Southwest Fort Worth. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Laurel Heights at Cityview gives you a focused collection of one and two bedroom apartment floor plans, from efficient one bedroom designs to roomier two bedroom, two bath layouts with extra separation and storage. Compare available homes by price, layout, and move-in timing, then picture the details that make daily routines feel easier: open-concept kitchens with pantries, granite countertops, stainless steel appliances, in-home washer and dryer sets, and generous walk-in closets.</p><p>Select homes add fireplaces, vaulted ceilings, or a private patio or balcony for a little more character. Browse the options below, explore more <a href=\"/amenities\">apartment features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how each floor plan lives in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details before you tour.</strong> Browse Laurel Heights at Cityview through bright, polished scenes: kitchens with dark cabinetry, granite countertops, subway tile, and stainless steel appliances; living rooms where wood-style flooring, large windows, and a fireplace add texture; and bedrooms with calm, neutral finishes. Outside, the gallery moves from sunlit pool decks and a rock-waterfall backdrop to grilling areas, courtyard seating, and green spaces for pets. It is a visual preview of how the community’s one and two bedroom apartments connect comfortable interiors with resort-inspired amenities in Fort Worth. Like what you see? Explore more <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to view the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Southwest Fort Worth from Cityview.</strong> Use the interactive map to browse available apartments and see how Laurel Heights connects you to everyday essentials, nearby shopping and dining, and easy routes to Fort Worth favorites via I-20, I-820, and Chisholm Trail Parkway.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with the extras built in.</strong> At Laurel Heights at Cityview, your cat or dog is part of the rhythm of home—from a quick morning loop through the community to playtime at the on-site Bark Park. After muddy paws or a warm Fort Worth walk, the Posh Pet Spa makes cleanup simple, while private patios and balconies give you an easy spot to unwind together.</p><p>Everyday pet care feels convenient here, too, with controlled access gates, walking and biking trails, and nearby options for supplies, grooming, and veterinary visits. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Laurel Heights at Cityview supports life with your four-legged companion.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Cityview convenience.</strong> Love your open-concept apartment, resort-style amenities, and easy Southwest Fort Worth access? Refer a friend to Laurel Heights at Cityview and invite them to find their next one or two bedroom home right here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made simple.</strong><br>Use the online resident services at Laurel Heights at Cityview to pay rent, submit maintenance requests, and manage your account anytime—so everyday apartment living stays as convenient as the Southwest Fort Worth location you call home.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from the residents.</strong> Reviews for Laurel Heights at Cityview consistently point to the same things: a well-kept community, prompt maintenance, and an office team that’s easy to reach when questions come up. Residents praise service that feels personal—one longtime resident says the team is “always very friendly, helpful and prompt,” while another notes maintenance is quick and courteous.</p><p>You’ll also see plenty of love for roomy apartments, clean pools, updated spaces, and everyday convenience that makes life feel simple. If you’re comparing apartments in Fort Worth, these reviews offer a real look at what stands out here. Explore the <a href=\"/amenities\">community features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Laurel Heights at Cityview for yourself.</p>",
  "property_created_at": "1752256706638",
  "property_scheduletour_blurb": "<p><strong>See Laurel Heights at Cityview in person.</strong> Tour one and two bedroom apartments with open-concept kitchens, granite countertops, stainless steel appliances, walk-in closets, in-home washer and dryer sets, and private outdoor space—then explore the resort-style community features that make every day feel more connected. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture Laurel Heights at Cityview: open-concept one and two bedroom apartments, polished finishes, everyday convenience, and resort-style spaces that make Southwest Fort Worth living feel easy.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Laurel Heights at Cityview before you arrive.</strong> These virtual tours let you move from community spaces to apartment interiors at your own pace, whether you’re comparing layouts or narrowing down favorite features. Explore the pool, fitness center, and leasing office, then step inside available apartment tours for a one-bedroom, one-bath layout and a two-bedroom, two-bath layout. As you click through, notice the flow of the rooms, kitchen storage, natural light, closet space, and how private patio or balcony living can extend your routine. When you’re ready to see more, compare <a href=\"/floor-plans\">available floor plans</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look.</p>",
  "property_copyright": "2025 All Rights Reserved. Laurel Heights at Cityview",
  "property_seo_title_home": "Laurel Heights at Cityview | Apartments in Fort Worth, TX",
  "property_seo_description_home": "Discover your dream home at Laurel Heights at Cityview in Fort Worth, TX! Choose from a variety of spacious one and two-bedroom floor plans and enjoy an array of exceptional amenities including a refreshing pool, fully-equipped fitness center, inviting clubhouse, and a fun-filled gameroom. With a pet-friendly dog park, scenic walking/biking trails, and delightful picnic areas, there’s something here for everyone. Experience convenience with door-to-door trash pickup, package service, and on-site maintenance. Don’t miss out—find your new home today at Laurel Heights at Cityview!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Fort Worth, TX",
  "property_seo_description_floorplans": "Discover your ideal home at Laurel Heights at Cityview in Fort Worth, TX! Explore our thoughtfully designed floor plans, featuring spacious one and two-bedroom apartments. Browse our available options today and find the perfect space tailored to your lifestyle!",
  "property_seo_title_amenities": "Amenities | Fort Worth, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your perfect home at Laurel Heights at Cityview in Fort Worth, TX! Choose from spacious one and two-bedroom floor plans while enjoying a wealth of top-notch amenities. Dive into relaxation with our sparkling pool, stay fit in the modern fitness center, and unwind in the clubhouse or gameroom. With a dog park, playground, and scenic walking/biking trails, there's something for everyone. Experience concierge services, door-to-door trash pickup, and planned social activities that create a vibrant community atmosphere. Ready to elevate your living experience? Explore our amazing community amenities today!",
  "property_seo_title_gallery": "Gallery | Apartments in Fort Worth, TX",
  "property_seo_description_gallery": "\"Discover your dream home at Laurel Heights at Cityview in Fort Worth, TX! Explore our diverse floor plans, including spacious one and two-bedroom apartments. Enjoy exceptional amenities like a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. With pet-friendly options, walking/biking trails, and planned social activities, life here is about comfort and community. Picture yourself living the good life—view our photo gallery now!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Laurel Heights at Cityview Apartments",
  "property_seo_description_virtualtours": "Discover your dream home at Laurel Heights at Cityview in Fort Worth, TX! Explore our spacious one and two-bedroom floor plans and experience the vibrant community from the comfort of your own home. Take a virtual tour of our beautiful apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | Laurel Heights at Cityview Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Laurel Heights at Cityview in Fort Worth, TX! Explore our spacious one and two-bedroom floor plans, all while enjoying an array of top-notch amenities like a refreshing pool, fully-equipped fitness center, and a vibrant clubhouse. Our community features a pet-friendly dog park, picnic areas, and scenic walking/biking trails. With convenient services like door-to-door trash pickup and on-site maintenance, your comfort is our priority. Use our interactive community map to search available apartments, view pricing, and select your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Fort Worth, TX",
  "property_seo_description_neighborhood": "Discover life at Laurel Heights at Cityview in Fort Worth, TX! Explore our diverse floor plans, including spacious one- and two-bedroom apartments, and immerse yourself in the vibrant neighborhood. See what's around our community and uncover local favorites and nearby points of interest that make living here truly special. Your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | Laurel Heights at Cityview",
  "property_seo_description_contact": "Discover your ideal home at Laurel Heights at Cityview in Fort Worth, TX! Our community offers impeccable one and two-bedroom floor plans designed for comfort and style. Have questions about our apartments? Contact our leasing team today for personalized assistance and make your move to a vibrant living experience!",
  "property_seo_title_faqs": "FAQs | Apartments in Fort Worth, TX",
  "property_seo_description_faqs": "Discover the exceptional lifestyle at Laurel Heights at Cityview in Fort Worth, TX! Explore our one and two-bedroom floor plans, designed with your comfort in mind. Enjoy top-notch amenities including a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Our community also features a pet play area, walking and biking trails, and a gameroom for endless fun. Have questions? Browse our FAQs page to find answers to your most pressing inquiries about our vibrant community and make Laurel Heights your new home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Fort Worth, TX",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at Laurel Heights at Cityview in Fort Worth, TX! Explore our spacious one- and two-bedroom apartments, complemented by exceptional amenities like a refreshing pool, state-of-the-art fitness center, and community lounge. Enjoy planned social activities, a cozy clubhouse, and pet-friendly features including a dog park and play area. Dive into resident experiences and see what our community members have to say about living here! Your dream apartment awaits—join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Fort Worth, TX",
  "property_seo_description_applynow": "Discover your dream apartment at Laurel Heights at Cityview in Fort Worth, TX! Browse our spacious one and two-bedroom floor plans and enjoy an abundance of amenities, including a refreshing pool, state-of-the-art fitness center, on-site maintenance, and a vibrant clubhouse. Your furry friends will love our pet play area while you relax in the cabana or picnic by the pond. Experience a true community with our planned social activities and enjoy hassle-free living with door-to-door trash pickup and package services. Apply now and find your new home—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Laurel Heights at Cityview",
  "property_seo_description_residentaccess": "\"Login to your Laurel Heights at Cityview resident portal in Fort Worth, TX! Easily pay rent, schedule maintenance, and manage your apartment needs all in one place. Access now for a seamless living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Laurel Heights at Cityview",
  "property_seo_description_referafriend": "\"Refer a friend to Laurel Heights at Cityview in Fort Worth, TX, and help them discover their new home! Great friends make great neighbors—share your love for our vibrant community and enjoy exclusive rewards. Join us today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Laurel Heights at Cityview",
  "property_seo_description_scheduletour": "Discover your dream home at Laurel Heights at Cityview in Fort Worth, TX! Experience luxury living in our vibrant community. Schedule a tour today and see why our apartments are the perfect place for you!",
  "property_seo_title_privacy": "Privacy Policy | Laurel Heights at Cityview",
  "property_seo_description_privacy": "\"Discover how Laurel Heights at Cityview in Fort Worth, TX, safeguards your personal information. Read our comprehensive privacy policy to learn about our commitment to your privacy and data security. Your peace of mind is our priority—View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Laurel Heights at Cityview",
  "property_seo_description_accessibility": "\"Discover Laurel Heights at Cityview in Fort Worth, TX, where accessibility meets comfort. Our commitment to digital inclusion ensures that every resident finds a welcoming home. Explore our Accessibility Statement to learn how we prioritize inclusivity for all. Join our community today!\"",
  "property_seo_title_sitemap": "Sitemap | Laurel Heights at Cityview",
  "property_seo_description_sitemap": "Discover the full offerings of Laurel Heights at Cityview in Fort Worth, TX! Explore our comprehensive sitemap to find your ideal apartment home, amenities, and community highlights. View our website sitemap today for easy navigation and discover your perfect living space!",
  "property_seo_title_thankyou": "Thank You | Laurel Heights at Cityview",
  "property_seo_description_thankyou": "Thank you for reaching out to Laurel Heights at Cityview in Fort Worth, TX! We appreciate your interest in our vibrant apartment community. A member of our friendly team will contact you shortly to assist with your inquiries. Discover the perfect blend of comfort and style at Laurel Heights today!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319998",
  "amenities": [
    {
      "id": "custom_93d47c78-444f-4c54-8acd-dab0ef82dd73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a8119a64-7e49-4807-9fd3-cf5b7d671614",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b38d5810-b967-485e-b386-93a72f841481",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18f4d0ef-094a-4a7b-af33-c5d5266fdaeb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Open Concept Kitchens w/ Pantries",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7830b24f-bfcc-4211-9eeb-566d10dd8099",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_662309bf-d408-4d2f-b9d0-8452b4d93ed1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6f60a48-393f-479c-a5f4-42ff65beb88a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000628",
      "title": "Dog Wash",
      "amount": "0.0000",
      "description": "Posh Pet Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e5d27a86-efdb-45b9-9f65-eb8761853c47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Fully-Equipped Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1bea086a-abc5-4251-82b8-9d2d11ae7f41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Faux Wood Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_768c8854-5411-429e-af7e-3dfd9f68cc69",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f4e58ac-4fb1-4e0c-b5e6-f99efc46711b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e889acc-fc36-4153-955c-15acbdfc0ed0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Outdoor Kitchen w/ Grilling Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_98442f8d-7073-4b47-925d-4ef403dda5d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82cb776a-cac0-4f4d-abc4-5db8af877cdf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca6e7da2-cbeb-41b8-ac24-6c7c7f3c7677",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000692",
      "title": "Tennis Court",
      "amount": "0.0000",
      "description": "Tennis Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4757f21b-676e-472a-b16d-473f5c20bb38",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6f29a7a-da9a-4640-8fb8-eb6e03907492",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0e93e74-0d1a-449f-ab4e-9fc272066f6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000002458",
      "title": "Valet Trash Service",
      "amount": "0.0000",
      "description": "Valet Trash Service",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_105a746d-c127-4445-b17c-32123571bb4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "external_id": "P000002459",
      "title": "Outdoor Living",
      "amount": "0.0000",
      "description": "Outdoor Picnic Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0eb9d847-c2ff-4005-986c-ecc2bd40781c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-2e77-70e4-afce-858703a395fd.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with stone waterfall and lounge chairs, adjacent to apartment buildings under a bright blue sky.",
        "public_id": "019e899f-2e77-70e4-afce-858703a395fd",
        "storage_key": "property/5753165609697280/019e899f-2e77-70e4-afce-858703a395fd.webp",
        "width": 3014,
        "height": 2006
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, complete with a natural stone waterfall feature. Perfect for soaking up the sun and enjoying the resort-style atmosphere.",
      "link": "",
      "alt_text": "Sparkling swimming pool with stone waterfall and lounge chairs, adjacent to apartment buildings under a bright blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fbf151b8-af4e-4ed3-a4b0-2ea5823793f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-2dff-71cd-8c24-5653894a5c3a.webp",
      "image_media": {
        "alt_text": "Dining area with table set for four and view of kitchen.",
        "public_id": "019e899f-2dff-71cd-8c24-5653894a5c3a",
        "storage_key": "property/5753165609697280/019e899f-2dff-71cd-8c24-5653894a5c3a.webp",
        "width": 3024,
        "height": 2012
      },
      "title": "Apartment",
      "description": "Elegant dining area adjacent to a modern kitchen, perfect for entertaining guests or enjoying a quiet meal.",
      "link": "",
      "alt_text": "Dining area with table set for four and view of kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70ac232e-5a94-4956-8863-ecb4e0df57b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-3081-754d-bbe0-b22199e3f4a1.webp",
      "image_media": {
        "alt_text": "Living room with a gray sectional sofa, fireplace, and large window.",
        "public_id": "019e899f-3081-754d-bbe0-b22199e3f4a1",
        "storage_key": "property/5753165609697280/019e899f-3081-754d-bbe0-b22199e3f4a1.webp",
        "width": 2420,
        "height": 1610
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, a modern fireplace, and ample natural light from a large window.",
      "link": "",
      "alt_text": "Living room with a gray sectional sofa, fireplace, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_328b4451-4a57-41da-9ca2-b3a4e9c20abb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-2b30-70fc-afb5-753e4563f5f1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019e899f-2b30-70fc-afb5-753e4563f5f1",
        "storage_key": "property/5753165609697280/019e899f-2b30-70fc-afb5-753e4563f5f1.webp",
        "width": 3024,
        "height": 2012
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully appointed kitchen featuring dark wood cabinets, granite countertops, and modern stainless steel appliances, including a microwave and refrigerator.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_69c27b41-7325-41c7-9280-0e276c914916",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-2e80-706d-9f8a-92b402029625.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and toilet with shower/tub combo.",
        "public_id": "019e899f-2e80-706d-9f8a-92b402029625",
        "storage_key": "property/5753165609697280/019e899f-2e80-706d-9f8a-92b402029625.webp",
        "width": 2714,
        "height": 1880
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern vanity, large mirror, and a clean shower/tub combination, perfect for everyday relaxation.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and toilet with shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35d1a2fc-de42-4518-9235-7b221c48ea6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-2d46-7684-906c-7939d066acc4.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, free weights, and weight machines.",
        "public_id": "019e899f-2d46-7684-906c-7939d066acc4",
        "storage_key": "property/5753165609697280/019e899f-2d46-7684-906c-7939d066acc4.webp",
        "width": 2740,
        "height": 1876
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring cardio equipment, free weights, and strength training machines.",
      "link": "",
      "alt_text": "Gym with cardio machines, free weights, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_467bb9e2-a73d-4a40-8b31-a499cd5f73e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-2d52-76cf-8976-48a6aa3af140.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a blue bed, nightstands, and dresser.",
        "public_id": "019e899f-2d52-76cf-8976-48a6aa3af140",
        "storage_key": "property/5753165609697280/019e899f-2d52-76cf-8976-48a6aa3af140.webp",
        "width": 2277,
        "height": 1602
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable blue upholstered bed, dark wood nightstands, and a dresser with a large mirror. Decorated with contemporary art and lamps.",
      "link": "",
      "alt_text": "Modern bedroom with a blue bed, nightstands, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4846f30f-f836-4b0e-899b-acb9d371c031",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-2786-703b-8246-43413514a463.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019e899f-2786-703b-8246-43413514a463",
        "storage_key": "property/5753165609697280/019e899f-2786-703b-8246-43413514a463.webp",
        "width": 2496,
        "height": 1740
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring stainless steel appliances, sleek granite countertops, and ample dark wood cabinetry for all your storage needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9845f7db-64fe-493b-88f3-1f51b461a750",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-2936-747f-9016-557508f42cef.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, fireplace, and a coffee table.",
        "public_id": "019e899f-2936-747f-9016-557508f42cef",
        "storage_key": "property/5753165609697280/019e899f-2936-747f-9016-557508f42cef.webp",
        "width": 2412,
        "height": 1605
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, elegant fireplace, and a stylish coffee table. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, fireplace, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aeb933f5-cd87-4ee8-b232-7386740b3400",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-1136-73e3-abf9-7ec7dd6906a3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature, with apartment buildings in the background.",
        "public_id": "019e899f-1136-73e3-abf9-7ec7dd6906a3",
        "storage_key": "property/5753165609697280/019e899f-1136-73e3-abf9-7ec7dd6906a3.webp",
        "width": 3016,
        "height": 2007
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and beautiful apartment homes. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8484e5e-be6b-44eb-949b-271f1b7f24ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-1063-75ab-8298-05b98a5d0b5b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019e899f-1063-75ab-8298-05b98a5d0b5b",
        "storage_key": "property/5753165609697280/019e899f-1063-75ab-8298-05b98a5d0b5b.webp",
        "width": 3024,
        "height": 2012
      },
      "title": "Apartment",
      "description": "Experience culinary delights in this beautifully appointed apartment kitchen, featuring sleek granite countertops, state-of-the-art stainless steel appliances, and rich dark wood cabinetry.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb542446-76e5-4fd5-b8c1-0b43946b1283",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-10d1-748f-90d9-1089eebb26ff.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with stone accents and a waterfall feature, surrounded by lush greenery and apartment buildings.",
        "public_id": "019e899f-10d1-748f-90d9-1089eebb26ff",
        "storage_key": "property/5753165609697280/019e899f-10d1-748f-90d9-1089eebb26ff.webp",
        "width": 3017,
        "height": 2007
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with a rock waterfall and sun-drenched lounging areas. A perfect oasis for relaxation.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with stone accents and a waterfall feature, surrounded by lush greenery and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af557f09-bcb1-4797-98a9-aa4d859565a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-1197-7551-a1b2-224cd29d254b.webp",
      "image_media": {
        "alt_text": "King size bed with plush pillows and a navy accent wall in a master bedroom.",
        "public_id": "019e899f-1197-7551-a1b2-224cd29d254b",
        "storage_key": "property/5753165609697280/019e899f-1197-7551-a1b2-224cd29d254b.webp",
        "width": 3024,
        "height": 2012
      },
      "title": "Apartment",
      "description": "Spacious master bedroom featuring a comfortable king-size bed, modern decor, and ample storage space.",
      "link": "",
      "alt_text": "King size bed with plush pillows and a navy accent wall in a master bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_817121f0-faa7-4aa8-903d-4a444a495aab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-0f16-76cc-bc7d-4eef25bab356.webp",
      "image_media": {
        "alt_text": "Dining area with a table set for four and a glimpse of the living room.",
        "public_id": "019e899f-0f16-76cc-bc7d-4eef25bab356",
        "storage_key": "property/5753165609697280/019e899f-0f16-76cc-bc7d-4eef25bab356.webp",
        "width": 3024,
        "height": 2012
      },
      "title": "Apartment",
      "description": "Stylish dining area with a table set for an intimate meal, featuring a plush carpet and elegant decor. Adjacent living space offers a comfortable setting.",
      "link": "",
      "alt_text": "Dining area with a table set for four and a glimpse of the living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4719864a-ffd0-4ac8-85e6-677d9871762a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-10e5-77ef-8356-8ebb5d3b8de1.webp",
      "image_media": {
        "alt_text": "Modern living room with a grey sectional sofa, fireplace, TV, and blue accent chairs.",
        "public_id": "019e899f-10e5-77ef-8356-8ebb5d3b8de1",
        "storage_key": "property/5753165609697280/019e899f-10e5-77ef-8356-8ebb5d3b8de1.webp",
        "width": 2382,
        "height": 1585
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable grey sectional, elegant fireplace, mounted TV, and stylish blue seating, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a grey sectional sofa, fireplace, TV, and blue accent chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec9f87cd-f0dd-466a-b3b1-1d8ce0483002",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-1095-704d-8f72-a963e70128d1.webp",
      "image_media": {
        "alt_text": "Washer and dryer with laundry basket and sign in a laundry room.",
        "public_id": "019e899f-1095-704d-8f72-a963e70128d1",
        "storage_key": "property/5753165609697280/019e899f-1095-704d-8f72-a963e70128d1.webp",
        "width": 3024,
        "height": 2012
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for all your laundry needs. Includes a laundry basket and 'Laundry Open 24 Hrs A Day' sign.",
      "link": "",
      "alt_text": "Washer and dryer with laundry basket and sign in a laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0908aa30-d707-49dc-8039-2b7a6bc8bae4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-1037-72c8-9732-4ef171c64e73.webp",
      "image_media": {
        "alt_text": "Spin bikes and weights in the property's fitness center.",
        "public_id": "019e899f-1037-72c8-9732-4ef171c64e73",
        "storage_key": "property/5753165609697280/019e899f-1037-72c8-9732-4ef171c64e73.webp",
        "width": 2420,
        "height": 1610
      },
      "title": "Community",
      "description": "Get your cardio in with our state-of-the-art spin bikes and well-equipped fitness center, featuring kettlebells and medicine balls.",
      "link": "",
      "alt_text": "Spin bikes and weights in the property's fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3dcadbf7-f51b-4dfa-9e1c-6ff56a31f046",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-0f05-700d-a6bb-b82f558db889.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, toilet and bathtub with shower.",
        "public_id": "019e899f-0f05-700d-a6bb-b82f558db889",
        "storage_key": "property/5753165609697280/019e899f-0f05-700d-a6bb-b82f558db889.webp",
        "width": 3024,
        "height": 2012
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a granite countertop vanity with a dual-handle faucet, a large framed mirror, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, mirror, toilet and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19b96cf5-7980-463a-aea4-d000bcef9ae2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e899f-0ee9-73df-8b5e-1d30aaa4f03d.webp",
      "image_media": {
        "alt_text": "Gym with cardio equipment, weight machines, and a blue turf area.",
        "public_id": "019e899f-0ee9-73df-8b5e-1d30aaa4f03d",
        "storage_key": "property/5753165609697280/019e899f-0ee9-73df-8b5e-1d30aaa4f03d.webp",
        "width": 2420,
        "height": 1610
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio machines, weight training equipment, and an open turf area for functional training.",
      "link": "",
      "alt_text": "Gym with cardio equipment, weight machines, and a blue turf area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_fe5ba23af930962a0b3755c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "5700 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-1bd0-76ba-819c-7d004d28dc56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1bd0-76ba-819c-7d004d28dc56",
        "storage_key": "property/5753165609697280/019f1506-1bd0-76ba-819c-7d004d28dc56.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/15784",
      "poi_directions_map_url": "https://maps.google.com/?cid=2248517089755257505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "32.6786656",
      "poi_longitude": "-97.4124364",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-423-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-847c-77d2-a93d-8968a4c459c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-847c-77d2-a93d-8968a4c459c0",
        "storage_key": "property/5753165609697280/019f1506-847c-77d2-a93d-8968a4c459c0.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJbWXvwWFtToYRodpBRmFWNB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_74b8103d529ea228f04c9283",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Pho & Grill",
      "poi_type": "Restaurants",
      "poi_address": "4954 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Popular eatery in a strip mall preparing Vietnamese favorites in an easygoing, contemporary space.",
      "poi_long_description": "Popular eatery in a strip mall preparing Vietnamese favorites in an easygoing, contemporary space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-1702-70dd-b816-32d6582fcda3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1702-70dd-b816-32d6582fcda3",
        "storage_key": "property/5753165609697280/019f1506-1702-70dd-b816-32d6582fcda3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://phofortworth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17200183062507286855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho--grill",
      "poi_latitude": "32.67729",
      "poi_longitude": "-97.402245",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-292-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl5fwRHxtToYRR_FvaF1Ts-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "ec_c3e6c3755f2ff3b7eb74a309",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Sushi Tao",
      "poi_type": "Restaurants",
      "poi_address": "4938 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Sleek sushi bar serving artfully prepared dishes including robata-grilled items & Japanese entrees.",
      "poi_long_description": "Sleek sushi bar serving artfully prepared dishes including robata-grilled items & Japanese entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-16b7-72c6-9a46-cfe4ac678955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-16b7-72c6-9a46-cfe4ac678955",
        "storage_key": "property/5753165609697280/019f1506-16b7-72c6-9a46-cfe4ac678955.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sushitao.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15804772219920145974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-tao",
      "poi_latitude": "32.6771302",
      "poi_longitude": "-97.4016041",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-294-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw6KxW3xtToYRNl5NxJjUVds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_9e29a8219795dd01257b08ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Freebirds World Burrito",
      "poi_type": "Restaurants",
      "poi_address": "4965 Overton Ridge Blvd #300, Fort Worth, TX 76132, USA",
      "poi_short_description": "Counter-serve, build-your-own-burrito chain with a natural-foods focus, also serving tacos & salads.",
      "poi_long_description": "Counter-serve, build-your-own-burrito chain with a natural-foods focus, also serving tacos & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-176b-7772-91a4-ba2794288309.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-176b-7772-91a4-ba2794288309",
        "storage_key": "property/5753165609697280/019f1506-176b-7772-91a4-ba2794288309.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.freebirds.com/locations/ridge-rock-4965-overton-ridge-blvd-ste-300-fort-worth-tx-76132",
      "poi_directions_map_url": "https://maps.google.com/?cid=7577719944723886080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freebirds-world-burrito",
      "poi_latitude": "32.6760809",
      "poi_longitude": "-97.4028506",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-294-7241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95oEXnxtToYRAPCoKCR4KWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_fb318cb7d3b194d23f75a35a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "SmackBird Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "Inside of Cowboy Chicken, 4972 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Straightforward delivery-only kitchen whipping up Nashville-style hot chicken sandwiches & tenders.",
      "poi_long_description": "Straightforward delivery-only kitchen whipping up Nashville-style hot chicken sandwiches & tenders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-1e11-773a-8405-c772938ec612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1e11-773a-8405-c772938ec612",
        "storage_key": "property/5753165609697280/019f1506-1e11-773a-8405-c772938ec612.webp",
        "width": 940,
        "height": 1165
      },
      "poi_business_url": "https://smackbird.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14554247553865713788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smackbird-hot-chicken",
      "poi_latitude": "32.6768679",
      "poi_longitude": "-97.4028343",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-214-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTDfW1xtToYRfIhD3QkT-8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_bcaf67e9ac03238308a89657",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "K-Town Hot Dogs",
      "poi_type": "Restaurants",
      "poi_address": "4940 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Popular hot-dog spot serves many flavor combinations, including pizza flavor or potato-coated.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-1ae2-7689-811d-6617ef10780f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1ae2-7689-811d-6617ef10780f",
        "storage_key": "property/5753165609697280/019f1506-1ae2-7689-811d-6617ef10780f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ktownhotdogs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10617376767366620031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k-town-hot-dogs",
      "poi_latitude": "32.6771519",
      "poi_longitude": "-97.4015438",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-386-5371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJebbY2BdtToYRf2Nfqep_WJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "ec_567cb7a74a995c6a8de6b970",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Kung Fu Tea",
      "poi_type": "Restaurants",
      "poi_address": "4946 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Bubble tea specialist with a selection of other hot & cold drinks, including coffee & slushes.",
      "poi_long_description": "Bubble tea specialist with a selection of other hot & cold drinks, including coffee & slushes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-20dc-707e-b2fd-92eca0315ecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-20dc-707e-b2fd-92eca0315ecf",
        "storage_key": "property/5753165609697280/019f1506-20dc-707e-b2fd-92eca0315ecf.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://kungfutea.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12505140603859883768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kung-fu-tea",
      "poi_latitude": "32.6771729",
      "poi_longitude": "-97.4017936",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-250-3113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSKfSXxtToYR-NZhxx8vi60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "ec_8a9b17d3c63d96ed57934ad1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Rosa's Café & Tortilla Factory",
      "poi_type": "Restaurants",
      "poi_address": "5000 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Fast-food chain featuring classic Mexican dishes & housemade tortillas in festive surroundings.",
      "poi_long_description": "Fast-food chain featuring classic Mexican dishes & housemade tortillas in festive surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-1345-7737-823d-db34ecc1986c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1345-7737-823d-db34ecc1986c",
        "storage_key": "property/5753165609697280/019f1506-1345-7737-823d-db34ecc1986c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rosascafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3346357924358093339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosas-caf--tortilla-factory",
      "poi_latitude": "32.6771503",
      "poi_longitude": "-97.4041132",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-361-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ--uL43xtToYRG3qtbM2mcC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c2c9ce2217b48f3b0e283979",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Kincaid's Hamburgers",
      "poi_type": "Restaurants",
      "poi_address": "4825 Overton Ridge Blvd Ste 328, Fort Worth, TX 76132, USA",
      "poi_short_description": "Spin-off of a circa-1946 burger joint famed for its old-fashioned, handmade patties.",
      "poi_long_description": "Spin-off of a circa-1946 burger joint famed for its old-fashioned, handmade patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-1654-745e-9e69-a4ddfe8f8730.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1654-745e-9e69-a4ddfe8f8730",
        "storage_key": "property/5753165609697280/019f1506-1654-745e-9e69-a4ddfe8f8730.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kincaidshamburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14927070849549275738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaids-hamburgers",
      "poi_latitude": "32.6760722",
      "poi_longitude": "-97.40027",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-370-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVXaR_NtToYRWhJ5xNmbJ88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_9b663f6144ae4c93edfe4136",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "（City View）Hokkaido ramen & sushi Fort Worth",
      "poi_type": "Restaurants",
      "poi_address": "5900 Overton Ridge Blvd Ste 130, Fort Worth, TX 76132, USA",
      "poi_short_description": "Warm eatery serving ramen dishes and sushi, along with bento boxes and bubble teas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-1dae-746c-82f6-222e169effd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1dae-746c-82f6-222e169effd7",
        "storage_key": "property/5753165609697280/019f1506-1dae-746c-82f6-222e169effd7.webp",
        "width": 1280,
        "height": 1067
      },
      "poi_business_url": "https://www.clover.com/online-ordering/hokkaido-ramen--sushi-fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=14288567121683666653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-viewhokkaido-ramen--sushi-fort-worth",
      "poi_latitude": "32.677456",
      "poi_longitude": "-97.41456",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 682-250-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UUwj0VtToYR3dZH1RcwS8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_c6fa027da739608b25e208e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Szechuan Restaurant Cityview",
      "poi_type": "Restaurants",
      "poi_address": "4750 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Longtime go-to for basic Chinese stir fries & noodles in a simple, quiet setting.",
      "poi_long_description": "Longtime go-to for basic Chinese stir fries & noodles in a simple, quiet setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-2892-7257-8ffc-a7ee7a711856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2892-7257-8ffc-a7ee7a711856",
        "storage_key": "property/5753165609697280/019f1506-2892-7257-8ffc-a7ee7a711856.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://szechuancityview.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14160070898380120608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "szechuan-restaurant-cityview",
      "poi_latitude": "32.679154",
      "poi_longitude": "-97.415961",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-346-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRo4-p9yToYRICJLdHWtgsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_a46320f457b1a41a1936251d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Razzoo's Cajun Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4700 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Local chain with New Orleans flavor serving bayou-inspired fare in a festive setting.",
      "poi_long_description": "Local chain with New Orleans flavor serving bayou-inspired fare in a festive setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-20d8-771d-a0b5-9fb7befb0367.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-20d8-771d-a0b5-9fb7befb0367",
        "storage_key": "property/5753165609697280/019f1506-20d8-771d-a0b5-9fb7befb0367.webp",
        "width": 512,
        "height": 280
      },
      "poi_business_url": "http://www.razzoos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10687519625735594200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "razzoos-cajun-cafe",
      "poi_latitude": "32.6804715",
      "poi_longitude": "-97.414858",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-292-8584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11BCw59yToYR2GD8hXmyUZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_60b4ac2d9cfec56544a7e7c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4608 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-250d-748b-b908-a4061eb84854.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-250d-748b-b908-a4061eb84854",
        "storage_key": "property/5753165609697280/019f1506-250d-748b-b908-a4061eb84854.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://locations.outback.com/texas/fort-worth/4608-bryant-irvin-road?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDI0MjUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3456644150935938722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "32.6814991",
      "poi_longitude": "-97.4148669",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-370-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxaV9J9yToYRouZ3i4p3-C8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_71ce62e3300a6be8b193828a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4913 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-2ed9-71d4-a1d7-acc9cc8a5044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2ed9-71d4-a1d7-acc9cc8a5044",
        "storage_key": "property/5753165609697280/019f1506-2ed9-71d4-a1d7-acc9cc8a5044.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/cityview?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9278424119475243404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.677407",
      "poi_longitude": "-97.4155446",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-423-8806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj2pHE2BtToYRjAm91JOVw4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_6df65cbc5d6636756bf91a09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Cousins BBQ",
      "poi_type": "Restaurants",
      "poi_address": "5125 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Self-serve eatery turning out BBQ smoked meats, sides & other fare in a functional space.",
      "poi_long_description": "Self-serve eatery turning out BBQ smoked meats, sides & other fare in a functional space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3339-7338-9e5c-d14f3d86b0cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3339-7338-9e5c-d14f3d86b0cf",
        "storage_key": "property/5753165609697280/019f1506-3339-7338-9e5c-d14f3d86b0cf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cousinsbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3441014028577816354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cousins-bbq",
      "poi_latitude": "32.675519",
      "poi_longitude": "-97.41697",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-346-3999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a02-759b-b3ae-a4ec8cc42c79",
        "storage_key": "property/5753165609697280/019f1502-5a02-759b-b3ae-a4ec8cc42c79.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDf8JI15tToYRIj-EGAfwwC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_0b5d27526d73eb347dbe5147",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "5700 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-2f40-7215-aeda-ab239eec4a80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2f40-7215-aeda-ab239eec4a80",
        "storage_key": "property/5753165609697280/019f1506-2f40-7215-aeda-ab239eec4a80.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/cityview/1770",
      "poi_directions_map_url": "https://maps.google.com/?cid=1933201032880140795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.6792234",
      "poi_longitude": "-97.4129573",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-423-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVedowGFtToYR-zE9zBgc1Bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_31e4f0509ef1b274705891db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5700 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-2da8-739b-95e5-060714f96072.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2da8-739b-95e5-060714f96072",
        "storage_key": "property/5753165609697280/019f1506-2da8-739b-95e5-060714f96072.webp",
        "width": 1280,
        "height": 1057
      },
      "poi_business_url": "https://www.cvs.com/store-locator/fort-worth-tx-pharmacies/5700-overton-ridge-blvd-fort-worth-tx-76132/storeid=16896?WT.mc_id=LS_GOOGLE_RX_16896",
      "poi_directions_map_url": "https://maps.google.com/?cid=12012281957520299287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.6792234",
      "poi_longitude": "-97.4129573",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-423-1661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-847e-764e-8009-2f49efdec11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-847e-764e-8009-2f49efdec11a",
        "storage_key": "property/5753165609697280/019f1506-847e-764e-8009-2f49efdec11a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVedowGFtToYRF9XU68sytKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_6017c39e4f3cc48633914e73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "5300 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-2d44-7485-82f0-0b07b3521a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2d44-7485-82f0-0b07b3521a2b",
        "storage_key": "property/5753165609697280/019f1506-2d44-7485-82f0-0b07b3521a2b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/fort-worth-TX-489.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8868950127388496786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "32.677542",
      "poi_longitude": "-97.4087336",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-210-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbzlaUWJtToYRkpOlsSbXFHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_91394848db101ab465c47a57",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "City View Towne Crossing, 5600 Overton Ridge Blvd F, Fort Worth, TX 76132, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-32ca-75ff-af1b-2d8eb7eb19d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-32ca-75ff-af1b-2d8eb7eb19d1",
        "storage_key": "property/5753165609697280/019f1506-32ca-75ff-af1b-2d8eb7eb19d1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.petco.com/tx/fort-worth/pet-supplies-fortworth-tx-497.html?utm_source=google&utm_campaign=locallist_497_pcc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1371998031711193122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petco",
      "poi_latitude": "32.6765399",
      "poi_longitude": "-97.4122367",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 817-423-1919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqa_rFmFtToYRIkiu0PBQChM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "ec_af54e3efe2ae3bc4f1b72932",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6300 Oakmont Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Retail outlet stocking housewares, furniture, electronics and clothing as well as pet supplies and groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3446-725d-8571-5bfc25c5c4a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3446-725d-8571-5bfc25c5c4a3",
        "storage_key": "property/5753165609697280/019f1506-3446-725d-8571-5bfc25c5c4a3.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/590-fort-worth-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11862334128876430144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.6645927",
      "poi_longitude": "-97.4054412",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-263-4065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2ejWGHJtToYRQCOsdgp6n6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_9d60585847a697fab37b6626",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "4400 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-364b-7679-a4b5-f268a419a3b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-364b-7679-a4b5-f268a419a3b3",
        "storage_key": "property/5753165609697280/019f1506-364b-7679-a4b5-f268a419a3b3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4742-fort-worth-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15584533072444446445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "32.688301",
      "poi_longitude": "-97.4142239",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-989-1992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJse9rBJlyToYR7dZgTUJiR9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_45ae1d7d201fce3dbab6d827",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Albertsons",
      "poi_type": "Shopping & Retail",
      "poi_address": "7400 Oakmont Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Grocery store featuring a bakery, deli, and pharmacy, plus online ordering.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3782-7258-a73e-1282fcd9b5b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3782-7258-a73e-1282fcd9b5b7",
        "storage_key": "property/5753165609697280/019f1506-3782-7258-a73e-1282fcd9b5b7.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://local.albertsons.com/tx/fort-worth/7400-oakmont-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5354056355137914093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertsons",
      "poi_latitude": "32.6629935",
      "poi_longitude": "-97.4197449",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-423-9556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f9-752c-b946-cef3375613a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f9-752c-b946-cef3375613a5",
        "storage_key": "property/5753165609697280/019f1502-59f9-752c-b946-cef3375613a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6UeTodSeToYR7QRrU-NtTUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_f88f04ca1ea39357fa1b0ee7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Dillard's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4850 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_long_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-378a-7374-845b-aa20fb661472.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-378a-7374-845b-aa20fb661472",
        "storage_key": "property/5753165609697280/019f1506-378a-7374-845b-aa20fb661472.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/stores/texas/hulen-mall-fort-worth/0704",
      "poi_directions_map_url": "https://maps.google.com/?cid=15364727986785424919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dillards",
      "poi_latitude": "32.6789379",
      "poi_longitude": "-97.3997045",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-294-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-VJHv35tToYRFxbZurJ6OtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_0883b6964b8ef4318b8c079c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "4921 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-39e5-7178-9f12-f565095e14ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-39e5-7178-9f12-f565095e14ef",
        "storage_key": "property/5753165609697280/019f1506-39e5-7178-9f12-f565095e14ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4921+bryant+irvin+rd-fort+worth-tx-76132/id=4857",
      "poi_directions_map_url": "https://maps.google.com/?cid=13942275796046512473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.6778521",
      "poi_longitude": "-97.4153195",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-292-5806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUvRbGBtToYRWQHhl_fpfME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_675f1a03c5d1796635e45eec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "4305 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-38ff-71f9-8aa5-0d242935a779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-38ff-71f9-8aa5-0d242935a779",
        "storage_key": "property/5753165609697280/019f1506-38ff-71f9-8aa5-0d242935a779.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Fort-Worth/0525?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-525-_-na-_-0-_-0&y_source=1_MTE4NDE1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13514762856604269258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.685818",
      "poi_longitude": "-97.408542",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-738-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN3qsgZtyToYRynqKuzYVjrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_e9942bbf4c2dcc1db90a27d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Oakmont Elementary School",
      "poi_type": "Education",
      "poi_address": "6651 Oakmont Trail, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.crowleyisdtx.org/oakmont",
      "poi_directions_map_url": "https://maps.google.com/?cid=12911687789857323516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakmont-elementary-school",
      "poi_latitude": "32.6540815",
      "poi_longitude": "-97.410592",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-370-5610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjwfUmhRtToYR_LkxxaKHL7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_dfea8f0affce3bc846a0f72b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Sue Crouch Elementary School",
      "poi_type": "Education",
      "poi_address": "8036 Cedar Lake Ln, Fort Worth, TX 76123, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.crowleyisdtx.org/suecrouch",
      "poi_directions_map_url": "https://maps.google.com/?cid=5636871640407197836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sue-crouch-elementary-school",
      "poi_latitude": "32.6256807",
      "poi_longitude": "-97.4098633",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-370-5670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU6REpOVsToYRjMjxOuQwOk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_4490e7370c1f04f0c62d3a47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Summer Creek Middle School",
      "poi_type": "Education",
      "poi_address": "10236 Summer Creek Dr, Crowley, TX 76036, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3a4a-72db-9a5c-ebd342885716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3a4a-72db-9a5c-ebd342885716",
        "storage_key": "property/5753165609697280/019f1506-3a4a-72db-9a5c-ebd342885716.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crowleyisdtx.org/summercreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=6215212496935846064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "summer-creek-middle-school",
      "poi_latitude": "32.6012285",
      "poi_longitude": "-97.4090724",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-297-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpZbzn5BsToYRsABuG9beQFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ab15f6d561065c108b62af5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "North Crowley High School",
      "poi_type": "Education",
      "poi_address": "9100 S Hulen St #2701, Fort Worth, TX 76123, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3b5b-7679-a483-cf4c67678e86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3b5b-7679-a483-cf4c67678e86",
        "storage_key": "property/5753165609697280/019f1506-3b5b-7679-a483-cf4c67678e86.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crowleyisdtx.org/nchs",
      "poi_directions_map_url": "https://maps.google.com/?cid=10652742441297602667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-crowley-high-school",
      "poi_latitude": "32.6106406",
      "poi_longitude": "-97.3944369",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-263-1250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVfuC-mNsToYRa2hFSc8k1pM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_ce99af1ebff1d5157aa96646",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Dallas Park Elementary School",
      "poi_type": "Education",
      "poi_address": "8700 Viridian Ln, Fort Worth, TX 76123, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3dca-71fb-b3e0-7706a02d520a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3dca-71fb-b3e0-7706a02d520a",
        "storage_key": "property/5753165609697280/019f1506-3dca-71fb-b3e0-7706a02d520a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.crowleyisdtx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=545783542116297355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-park-elementary-school",
      "poi_latitude": "32.6143254",
      "poi_longitude": "-97.3941797",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-370-5620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9Wpkc2BsToYRi6oYaD0Dkwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_82c12cf6295930adde07dbd5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Crowley Middle School",
      "poi_type": "Education",
      "poi_address": "3800 W Risinger Rd, Fort Worth, TX 76123, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.crowleyisdtx.org/cms",
      "poi_directions_map_url": "https://maps.google.com/?cid=13132225020770142699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crowley-middle-school",
      "poi_latitude": "32.6164275",
      "poi_longitude": "-97.3764076",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-370-5650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy2JaF0BsToYR60mAMRQJP7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_73a90d853c10ee6c025f6713",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "The Children's Courtyard on Bryant Irvin Road",
      "poi_type": "Education",
      "poi_address": "6200 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Chain day-care center offering a School Readiness Pathway for infants through school-age children.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3c3e-70fd-96aa-88afc369d977.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3c3e-70fd-96aa-88afc369d977",
        "storage_key": "property/5753165609697280/019f1506-3c3e-70fd-96aa-88afc369d977.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://www.childrenscourtyard.com/your-local-school/fort-worth-tx-3073/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=3073",
      "poi_directions_map_url": "https://maps.google.com/?cid=1501114993146587367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-courtyard-on-bryant-irvin-road",
      "poi_latitude": "32.6599283",
      "poi_longitude": "-97.4267703",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 866-561-3412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiRlcJUZtToYR5-iDDSII1RQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_270a6014cf1530a06e13c236",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Primrose School of Fort Worth at Mira Vista",
      "poi_type": "Education",
      "poi_address": "6410 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3c8d-75f0-aa49-febfb9d2de9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3c8d-75f0-aa49-febfb9d2de9e",
        "storage_key": "property/5753165609697280/019f1506-3c8d-75f0-aa49-febfb9d2de9e.webp",
        "width": 1095,
        "height": 616
      },
      "poi_business_url": "https://www.primroseschools.com/schools/fort-worth-at-mira-vista/??utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=14118921164130097816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-fort-worth-at-mira-vista",
      "poi_latitude": "32.6574996",
      "poi_longitude": "-97.4285209",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-880-9499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQd8SGuZtToYRmBq4V_578MM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_a424be4e46d337fed81e5081",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "La Petite Academy on Crosslands Rd",
      "poi_type": "Education",
      "poi_address": "4151 Crosslands Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-3ee3-73dd-ac72-1b60ce73383b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3ee3-73dd-ac72-1b60ce73383b",
        "storage_key": "property/5753165609697280/019f1506-3ee3-73dd-ac72-1b60ce73383b.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/fort-worth-tx-7553/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7553",
      "poi_directions_map_url": "https://maps.google.com/?cid=6934584772048140064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-crosslands-rd",
      "poi_latitude": "32.690588",
      "poi_longitude": "-97.418913",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ36421aJyToYRIDfD8huYPGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_2b2a906c84f1b99bdbdeffa9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "The Learning Experience - Fort Worth Summer Creek",
      "poi_type": "Education",
      "poi_address": "7345 Canyon Park Dr, Fort Worth, TX 76123, USA",
      "poi_short_description": "Chain providing child care and early education for infants, toddlers, and preschool-age children.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-406d-76d8-a294-df5464e5f5f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-406d-76d8-a294-df5464e5f5f6",
        "storage_key": "property/5753165609697280/019f1506-406d-76d8-a294-df5464e5f5f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thelearningexperience.com/centers/fort-worth-summer-creek/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10004072732757525276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-learning-experience---fort-worth-summer-creek",
      "poi_latitude": "32.6338715",
      "poi_longitude": "-97.4066614",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 682-250-4096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59be-73bb-a1ae-3b795f8f2235",
        "storage_key": "property/5753165609697280/019f1502-59be-73bb-a1ae-3b795f8f2235.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIz58m_DTTYYRHAMvhyWb1Yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_e249d1f54966c12836593c54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Movie Tavern Hulen",
      "poi_type": "Entertainment",
      "poi_address": "4920 S Hulen St, Fort Worth, TX 76132, USA",
      "poi_short_description": "Theater showing new releases paired with gourmet eats & cocktails available at the push of a button.",
      "poi_long_description": "Theater showing new releases paired with gourmet eats & cocktails available at the push of a button.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4024-762a-ba95-b5adcd38dfbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4024-762a-ba95-b5adcd38dfbb",
        "storage_key": "property/5753165609697280/019f1506-4024-762a-ba95-b5adcd38dfbb.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.movietavern.com/locations/hulen",
      "poi_directions_map_url": "https://maps.google.com/?cid=18375411477352076997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "movie-tavern-hulen",
      "poi_latitude": "32.677975",
      "poi_longitude": "-97.401385",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-546-7090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-84c4-743d-898b-3bfd73d07b16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-84c4-743d-898b-3bfd73d07b16",
        "storage_key": "property/5753165609697280/019f1506-84c4-743d-898b-3bfd73d07b16.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwr3yH1tToYRxdY0rWGTAv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_0cd7e481e717a89ea9aeb431",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Billy Bob's Texas",
      "poi_type": "Entertainment",
      "poi_address": "2520 Rodeo Plaza, Fort Worth, TX 76164, USA",
      "poi_short_description": "Famed, huge country music honky tonk with a live bull-riding arena, plus dozens of bars.",
      "poi_long_description": "Famed, huge country music honky tonk with a live bull-riding arena, plus dozens of bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4143-7654-a7d3-5e53714624a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4143-7654-a7d3-5e53714624a5",
        "storage_key": "property/5753165609697280/019f1506-4143-7654-a7d3-5e53714624a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://billybobstexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628500597275260219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "billy-bobs-texas",
      "poi_latitude": "32.791326",
      "poi_longitude": "-97.34743",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 817-624-7117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJicMctaZ2ToYRO3XijxEGWzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_3a3a81a59139c211f414df2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Modern Art Museum of Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "3200 Darnell St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Acclaimed contemporary complex with a reflecting pool housing more than 3,000 post-WWII artworks.",
      "poi_long_description": "Acclaimed contemporary complex with a reflecting pool housing more than 3,000 post-WWII artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-253e-700e-9a15-04f5e6f503a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-253e-700e-9a15-04f5e6f503a8",
        "storage_key": "property/5753165609697280/019f1502-253e-700e-9a15-04f5e6f503a8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.themodern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12620084409265249041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "modern-art-museum-of-fort-worth",
      "poi_latitude": "32.7491803",
      "poi_longitude": "-97.3633072",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-738-9215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f3-7468-b714-167018625fca",
        "storage_key": "property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5w_isJzToYREVuz-eeLI68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_7e3c14a34a8d8fbdcbf13dc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Kimbell Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "3333 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Renowned Asian- & European-focused collection plus exhibits set in a Louis Kahn-designed building.",
      "poi_long_description": "Renowned Asian- & European-focused collection plus exhibits set in a Louis Kahn-designed building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-2a4c-70a3-ac6b-1681867ec5a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-2a4c-70a3-ac6b-1681867ec5a6",
        "storage_key": "property/5753165609697280/019f1502-2a4c-70a3-ac6b-1681867ec5a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kimbellart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7239859824201680144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kimbell-art-museum",
      "poi_latitude": "32.7485687",
      "poi_longitude": "-97.3649208",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-332-8451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f3-7468-b714-167018625fca",
        "storage_key": "property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_3ggMJzToYREMUp1SYmeWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_fcd8d12f59feebf3e29d8cb0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Amon Carter Museum of American Art",
      "poi_type": "Entertainment",
      "poi_address": "3501 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Western artworks including those by Remington & Russell, plus Hudson River School paintings & more.",
      "poi_long_description": "Western artworks including those by Remington & Russell, plus Hudson River School paintings & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-47d5-7494-b6e3-ad96d4d2a833.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-47d5-7494-b6e3-ad96d4d2a833",
        "storage_key": "property/5753165609697280/019f1506-47d5-7494-b6e3-ad96d4d2a833.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cartermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2896534922228772865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amon-carter-museum-of-american-art",
      "poi_latitude": "32.747867",
      "poi_longitude": "-97.368447",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-738-1933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f3-7468-b714-167018625fca",
        "storage_key": "property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbcQcjcFzToYRAbD1TiqPMig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_6b86fe9b344556a0300b636f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Fort Worth Museum of Science and History",
      "poi_type": "Entertainment",
      "poi_address": "1600 Gendy St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Hands-on science exhibits, a planetarium & IMAX films in a large-scale, child-friendly venue.",
      "poi_long_description": "Hands-on science exhibits, a planetarium & IMAX films in a large-scale, child-friendly venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-2361-741c-849a-864d1081e9aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-2361-741c-849a-864d1081e9aa",
        "storage_key": "property/5753165609697280/019f1502-2361-741c-849a-864d1081e9aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fwmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3157640673865477658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-museum-of-science-and-history",
      "poi_latitude": "32.7441334",
      "poi_longitude": "-97.3692048",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-255-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f3-7468-b714-167018625fca",
        "storage_key": "property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-dqJcFzToYRGq4ThnYx0is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_334a162beafd0de4353fd61c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "National Cowgirl Museum & Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "1720 Gendy St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Exhibits, films & gift shop celebrating women who shaped the American West & modern day heroines.",
      "poi_long_description": "Exhibits, films & gift shop celebrating women who shaped the American West & modern day heroines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-44cf-71c8-bbd3-2e2a341dfd61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-44cf-71c8-bbd3-2e2a341dfd61",
        "storage_key": "property/5753165609697280/019f1506-44cf-71c8-bbd3-2e2a341dfd61.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://www.cowgirl.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4068204186215491438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-cowgirl-museum--hall-of-fame",
      "poi_latitude": "32.7432988",
      "poi_longitude": "-97.3687909",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-336-4475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f3-7468-b714-167018625fca",
        "storage_key": "property/5753165609697280/019f1502-59f3-7468-b714-167018625fca.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0azVvMZzToYRbqchMScqdTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_c3004c9c38afab9743b737b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Fort Worth Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1989 Colonial Pkwy, Fort Worth, TX 76110, USA",
      "poi_short_description": "Acclaimed attraction housing 7,000 animals in themed habitats, plus interactive activities & camps.",
      "poi_long_description": "Acclaimed attraction housing 7,000 animals in themed habitats, plus interactive activities & camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-2155-70ef-b9b1-f73b4b84f539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-2155-70ef-b9b1-f73b4b84f539",
        "storage_key": "property/5753165609697280/019f1502-2155-70ef-b9b1-f73b4b84f539.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://www.fortworthzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4707172094723069637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-zoo",
      "poi_latitude": "32.7231585",
      "poi_longitude": "-97.3564467",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-759-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO72Uyi1yToYRxZaZmhQ8U0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_e49601f1de2fa8210a3cf9e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "NRH2O Family Water Park",
      "poi_type": "Entertainment",
      "poi_address": "9001 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_long_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4741-741e-b374-1901c30c304d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4741-741e-b374-1901c30c304d",
        "storage_key": "property/5753165609697280/019f1506-4741-741e-b374-1901c30c304d.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.nrh2o.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1179881649457106072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh2o-family-water-park",
      "poi_latitude": "32.8500662",
      "poi_longitude": "-97.1945008",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "7 hours 16 mins",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 817-427-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxJqg7h4ToYRmIzk4BvIXxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_6f019004a6d32426152494ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Coyote Drive-In (Fort Worth)",
      "poi_type": "Entertainment",
      "poi_address": "223 NE 4th St, Fort Worth, TX 76164, USA",
      "poi_short_description": "Outdoor double features with a big, covered concession area serving local brews, plus a playground.",
      "poi_long_description": "Outdoor double features with a big, covered concession area serving local brews, plus a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4962-7156-90a5-1aef38199986.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4962-7156-90a5-1aef38199986",
        "storage_key": "property/5753165609697280/019f1506-4962-7156-90a5-1aef38199986.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://coyotedrive-in.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12921250732298654463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coyote-drive-in-fort-worth",
      "poi_latitude": "32.7647781",
      "poi_longitude": "-97.3354845",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-717-7767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-84c4-743d-898b-3bfd73d07b16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-84c4-743d-898b-3bfd73d07b16",
        "storage_key": "property/5753165609697280/019f1506-84c4-743d-898b-3bfd73d07b16.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0sVak9xToYR_9Jq0BSBUbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_ca0b173cf0e1aecf1fffdbd3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hospital Southwest Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "6100 Harris Pkwy, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-477d-758e-8239-ba9ab0934428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-477d-758e-8239-ba9ab0934428",
        "storage_key": "property/5753165609697280/019f1506-477d-758e-8239-ba9ab0934428.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-southwest-fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=17731957295412397178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hospital-southwest-fort-worth",
      "poi_latitude": "32.6577313",
      "poi_longitude": "-97.4208753",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-433-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f7-714d-b29a-5aa73049b21d",
        "storage_key": "property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2dlv0BtToYResRzVTaRFPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_68a9a9d9b207fb06702dd22c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - South Hulen",
      "poi_type": "Health and Wellness",
      "poi_address": "5001 S Hulen St, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4839-726f-8bb4-707eac81e13f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4839-726f-8bb4-707eac81e13f",
        "storage_key": "property/5753165609697280/019f1506-4839-726f-8bb4-707eac81e13f.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://carenow.com/locations/dallas-fort-worth/south-hulen?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4999745805652239008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---south-hulen",
      "poi_latitude": "32.6746134",
      "poi_longitude": "-97.3978523",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 682-610-1670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfSeU4dxtToYRoKImCVKqYkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f5ee80e3ef7a1dbc3d7b366b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Texas Health Breeze Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4480 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-49c9-731b-8cc3-c898bf3f645a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-49c9-731b-8cc3-c898bf3f645a",
        "storage_key": "property/5753165609697280/019f1506-49c9-731b-8cc3-c898bf3f645a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://breeze.care.texashealth.org/locations/urgent-care-bryant-irvin-fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529406552902039019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-breeze-urgent-care",
      "poi_latitude": "32.685082",
      "poi_longitude": "-97.4146111",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 682-212-9160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyJwC29zToYR63WR95Mbwrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_52104ccc5ca771309ac83ad4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "TrinityXpressMed",
      "poi_type": "Health and Wellness",
      "poi_address": "7440 Oakmont Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4bd1-7359-8ace-89fd3076c179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4bd1-7359-8ace-89fd3076c179",
        "storage_key": "property/5753165609697280/019f1506-4bd1-7359-8ace-89fd3076c179.webp",
        "width": 1280,
        "height": 676
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10935567175016620503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinityxpressmed",
      "poi_latitude": "32.6622776",
      "poi_longitude": "-97.4209879",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-423-1477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU1ywrtjXTYYR16FJFGjwwpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_ed69db7bfa9b282bff2e51ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5700 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-2da8-739b-95e5-060714f96072.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2da8-739b-95e5-060714f96072",
        "storage_key": "property/5753165609697280/019f1506-2da8-739b-95e5-060714f96072.webp",
        "width": 1280,
        "height": 1057
      },
      "poi_business_url": "https://www.cvs.com/store-locator/fort-worth-tx-pharmacies/5700-overton-ridge-blvd-fort-worth-tx-76132/storeid=16896?WT.mc_id=LS_GOOGLE_RX_16896",
      "poi_directions_map_url": "https://maps.google.com/?cid=12012281957520299287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.6792234",
      "poi_longitude": "-97.4129573",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-423-1661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-847e-764e-8009-2f49efdec11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-847e-764e-8009-2f49efdec11a",
        "storage_key": "property/5753165609697280/019f1506-847e-764e-8009-2f49efdec11a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVedowGFtToYRF9XU68sytKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a2e16469beab5e319db7c82c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4921 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-39e5-7178-9f12-f565095e14ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-39e5-7178-9f12-f565095e14ef",
        "storage_key": "property/5753165609697280/019f1506-39e5-7178-9f12-f565095e14ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4921+bryant+irvin+rd-fort+worth-tx-76132/id=4857",
      "poi_directions_map_url": "https://maps.google.com/?cid=13942275796046512473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.6778521",
      "poi_longitude": "-97.4153195",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-292-5806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUvRbGBtToYRWQHhl_fpfME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_f455d78de946fb85d2c37df4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "6080 S Hulen St, Fort Worth, TX 76132, USA",
      "poi_short_description": "Big gym with free weights and cardio and strength-training equipment, plus basketball and sauna areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-3026-70ac-86e8-ace667d7af4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-3026-70ac-86e8-ace667d7af4a",
        "storage_key": "property/5753165609697280/019f1502-3026-70ac-86e8-ace667d7af4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/hulen/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11618514866774949645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "32.6594452",
      "poi_longitude": "-97.4015306",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-361-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX2sFXXNtToYRDT-3u7ZBPaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_182ba407ee21e4150f4f329a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Amped Fitness (Hulen)",
      "poi_type": "Health and Wellness",
      "poi_address": "6242 Hulen Bend Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4ca7-7269-8117-0c252be47178.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4ca7-7269-8117-0c252be47178",
        "storage_key": "property/5753165609697280/019f1506-4ca7-7269-8117-0c252be47178.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://ampedfitness.com/join-hulen",
      "poi_directions_map_url": "https://maps.google.com/?cid=6881280198090070499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amped-fitness-hulen",
      "poi_latitude": "32.6615393",
      "poi_longitude": "-97.4043328",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 682-224-2133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyT_kyEltToYR45kWr-E3f18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_059ae505498beb2950760abf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Smart Barre Cityview",
      "poi_type": "Health and Wellness",
      "poi_address": "6080 S Hulen St #320, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4d68-72ce-ab04-84c9667de7a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4d68-72ce-ab04-84c9667de7a0",
        "storage_key": "property/5753165609697280/019f1506-4d68-72ce-ab04-84c9667de7a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8623003935820526037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smart-barre-cityview",
      "poi_latitude": "32.6586943",
      "poi_longitude": "-97.4029308",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-95v5nJtToYR1bFgm2QQq3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_a2b1360f4fb6a0b92192a60e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Baylor Scott & White All Saints Medical Center - Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-368b-704f-a000-da493ab50827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-368b-704f-a000-da493ab50827",
        "storage_key": "property/5753165609697280/019f1502-368b-704f-a000-da493ab50827.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/fort-worth?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-8119502",
      "poi_directions_map_url": "https://maps.google.com/?cid=14939051515624993574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-all-saints-medical-center---fort-worth",
      "poi_latitude": "32.7295641",
      "poi_longitude": "-97.3452152",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-926-2544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f7-714d-b29a-5aa73049b21d",
        "storage_key": "property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8FWXkJtToYRJrMW9jMsUs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_ed829e4cc30bf46ddeb6dd98",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Oakmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7000 Bellaire Dr S, Fort Worth, TX 76132, USA",
      "poi_short_description": "Park featuring play equipment, open grasslands, and paved pathways perfect for walking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-5261-70eb-af74-630d943f7a1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-5261-70eb-af74-630d943f7a1b",
        "storage_key": "property/5753165609697280/019f1506-5261-70eb-af74-630d943f7a1b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://fortworthtexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11299547864939480326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakmont-park",
      "poi_latitude": "32.6701662",
      "poi_longitude": "-97.4313581",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a18-77cc-bac0-641a9e703450",
        "storage_key": "property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6CCK1JtToYRBsU9ZOoO0Jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7964cda96882e2eb2b93c572",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Oakmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7000 Bellaire Dr S, Fort Worth, TX 76132, USA",
      "poi_short_description": "Park featuring play equipment, open grasslands, and paved pathways perfect for walking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-578c-721e-9540-7b8ebaa47eec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-578c-721e-9540-7b8ebaa47eec",
        "storage_key": "property/5753165609697280/019f1506-578c-721e-9540-7b8ebaa47eec.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://fortworthtexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11299547864939480326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakmont-park",
      "poi_latitude": "32.6701662",
      "poi_longitude": "-97.4313581",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a18-77cc-bac0-641a9e703450",
        "storage_key": "property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6CCK1JtToYRBsU9ZOoO0Jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a3132ff60dc40efe6bbfb63f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Quail Ridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7451 Dutch Branch Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-500d-74c4-9086-c961d3051266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-500d-74c4-9086-c961d3051266",
        "storage_key": "property/5753165609697280/019f1506-500d-74c4-9086-c961d3051266.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fortworthtexas.gov/parks/park-map.pdf",
      "poi_directions_map_url": "https://maps.google.com/?cid=11430361978447699484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quail-ridge-park",
      "poi_latitude": "32.652724",
      "poi_longitude": "-97.4232265",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a18-77cc-bac0-641a9e703450",
        "storage_key": "property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ26jZ4fFtToYRHJ6Bo6jNoJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_4d348e45a1c1e24286a4b21b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Trinity Trails River Park Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3100 Bryant Irvin Rd, Fort Worth, TX 76109, USA",
      "poi_short_description": "Trails for hiking, biking, and trail running along the Trinity River, plus playgrounds and grills.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-500c-74fd-9b36-5e8829c65f12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-500c-74fd-9b36-5e8829c65f12",
        "storage_key": "property/5753165609697280/019f1506-500c-74fd-9b36-5e8829c65f12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trinitytrailsfw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1981174104459858938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-trails-river-park-trailhead",
      "poi_latitude": "32.7058977",
      "poi_longitude": "-97.4123514",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-335-2491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a18-77cc-bac0-641a9e703450",
        "storage_key": "property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjykIp-tyToYR-lOI7lmLfhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a1ffa9e296ac5b1910c9d252",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Pecan Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6400 Pecan Valley Dr, Fort Worth, TX 76132, USA",
      "poi_short_description": "Serene green space with walking/biking trails, fishing spots, picnic tables & seasonal wild flowers.",
      "poi_long_description": "Serene green space with walking/biking trails, fishing spots, picnic tables & seasonal wild flowers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-4fc8-72cc-86d8-6cc8219e851e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-4fc8-72cc-86d8-6cc8219e851e",
        "storage_key": "property/5753165609697280/019f1506-4fc8-72cc-86d8-6cc8219e851e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fortworthtexas.gov/departments/parks/parks-and-trails/pecan-valley-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17232280071538007277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pecan-valley-park",
      "poi_latitude": "32.6577935",
      "poi_longitude": "-97.4516578",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a18-77cc-bac0-641a9e703450",
        "storage_key": "property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRzVztLkSToYR7dwQrmxbJe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_58cf650111c31c0b71148870",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Arrow S Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7951 Cahoba Dr, Fort Worth, TX 76135, USA",
      "poi_short_description": "Kid-friendly park with lakes (swimming prohibited), trails, picnic tables and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-545e-705f-958c-c58a835f178e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-545e-705f-958c-c58a835f178e",
        "storage_key": "property/5753165609697280/019f1506-545e-705f-958c-c58a835f178e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fortworthtexas.gov/departments/parks/parks-and-trails/arrow-s-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=684604818059836080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arrow-s-park",
      "poi_latitude": "32.7954675",
      "poi_longitude": "-97.4533881",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 45 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a18-77cc-bac0-641a9e703450",
        "storage_key": "property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29GyijkLToYRsDr6b3Q0gAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c55f618fa22004260997e0e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Kellis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4651 S Ridge Terrace, Fort Worth, TX 76133, USA",
      "poi_short_description": "Park featuring playgrounds, basketball and tennis courts, plus a creek and a merry-go-round.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-5580-717e-9d4e-afdb6b84a1c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-5580-717e-9d4e-afdb6b84a1c7",
        "storage_key": "property/5753165609697280/019f1506-5580-717e-9d4e-afdb6b84a1c7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://fortworthtexas.gov/parks/info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11704375266639958413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kellis-park",
      "poi_latitude": "32.6805139",
      "poi_longitude": "-97.3702262",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a18-77cc-bac0-641a9e703450",
        "storage_key": "property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4p7ofVtToYRjVHx5UpLbqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3f450390f408ff89be64114e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "US Army Corps of Engineers Benbrook Lake Office",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7001 Lakeside Dr, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-5b03-74e4-96e2-1cb0d3389c53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-5b03-74e4-96e2-1cb0d3389c53",
        "storage_key": "property/5753165609697280/019f1506-5b03-74e4-96e2-1cb0d3389c53.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.swf-wc.usace.army.mil/benbrook/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17607593980718211877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-army-corps-of-engineers-benbrook-lake-office",
      "poi_latitude": "32.6478877",
      "poi_longitude": "-97.444136",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-292-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-84d5-772e-8a83-8ca2f65aeba6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-84d5-772e-8a83-8ca2f65aeba6",
        "storage_key": "property/5753165609697280/019f1506-84d5-772e-8a83-8ca2f65aeba6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzW9gms4SToYRJeMDum-9WvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_6ba65f9e9b6f0693a75e8d66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Westhaven Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4801 Westhaven Dr, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-5579-7443-a666-df54f9b1310e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-5579-7443-a666-df54f9b1310e",
        "storage_key": "property/5753165609697280/019f1506-5579-7443-a666-df54f9b1310e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=806684618842975047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westhaven-park",
      "poi_latitude": "32.6776089",
      "poi_longitude": "-97.39257",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a18-77cc-bac0-641a9e703450",
        "storage_key": "property/5753165609697280/019f1502-5a18-77cc-bac0-641a9e703450.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKaYPCJ5tToYRRyvoB2PrMQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2b1f67b5dad9b0b2a3f696f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Hulen Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "4800 S Hulen St, Fort Worth, TX 76132, USA",
      "poi_short_description": "Relaxed mall with department stores, fashion chains & a food court, plus open-air restaurants.",
      "poi_long_description": "Relaxed mall with department stores, fashion chains & a food court, plus open-air restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-1996-7756-88cd-4b55228df0bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-1996-7756-88cd-4b55228df0bb",
        "storage_key": "property/5753165609697280/019f1502-1996-7756-88cd-4b55228df0bb.webp",
        "width": 1280,
        "height": 510
      },
      "poi_business_url": "https://www.hulenmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13236024106689965422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hulen-mall",
      "poi_latitude": "32.678639",
      "poi_longitude": "-97.398763",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-294-1205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0WfwT35tToYRbi3DLczNr7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_4e8392712f1d065ab2e00534",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Ridgmar Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "1888 Green Oaks Rd, Fort Worth, TX 76116, USA",
      "poi_short_description": "2-story mall attracting visitors for its well-known department stores, food court & aquarium.",
      "poi_long_description": "2-story mall attracting visitors for its well-known department stores, food court & aquarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-5bd5-74b9-9000-260f77059ff6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-5bd5-74b9-9000-260f77059ff6",
        "storage_key": "property/5753165609697280/019f1506-5bd5-74b9-9000-260f77059ff6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ridgmar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2127979923518851799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridgmar-mall",
      "poi_latitude": "32.740738",
      "poi_longitude": "-97.4370442",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-731-6591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo0_yuEtzToYR1wqBRncaiB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_a1f2d353e25346c99b3a9d36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "La Gran Plaza de Fort Worth",
      "poi_type": "Transportation & Transit",
      "poi_address": "4200 South Fwy Mall, Fort Worth, TX 76115, USA",
      "poi_short_description": "Community shopping center offering 200+ stores, a movie theater & live entertainment on weekends.",
      "poi_long_description": "Community shopping center offering 200+ stores, a movie theater & live entertainment on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-1983-71cb-bea2-de1227feecc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-1983-71cb-bea2-de1227feecc0",
        "storage_key": "property/5753165609697280/019f1502-1983-71cb-bea2-de1227feecc0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lagranplazamall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=842039262798139534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-gran-plaza-de-fort-worth",
      "poi_latitude": "32.6872481",
      "poi_longitude": "-97.3245901",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-922-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe-OBz1V2ToYRjtADij-Grws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_700dc39aa70d664d38b4936c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Fort Worth Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-5e31-70ed-a9a8-88de48f148ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-5e31-70ed-a9a8-88de48f148ec",
        "storage_key": "property/5753165609697280/019f1506-5e31-70ed-a9a8-88de48f148ec.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666534907176730361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-central",
      "poi_latitude": "32.7526669",
      "poi_longitude": "-97.3264798",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a14-71f1-aeba-d8423ba1d6ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a14-71f1-aeba-d8423ba1d6ed",
        "storage_key": "property/5753165609697280/019f1502-5a14-71f1-aeba-d8423ba1d6ed.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbEKLz5xToYR-b7q6jFtS-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_c20ec86bd95e86b731fb607e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Fort Worth T&p",
      "poi_type": "Transportation & Transit",
      "poi_address": "221 W Lancaster Ave, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-5e93-75ce-8b60-11a1dc04e464.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-5e93-75ce-8b60-11a1dc04e464",
        "storage_key": "property/5753165609697280/019f1506-5e93-75ce-8b60-11a1dc04e464.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/fort-worth-tp-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2586634399591785905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-tp",
      "poi_latitude": "32.7453226",
      "poi_longitude": "-97.3279067",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5a14-71f1-aeba-d8423ba1d6ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5a14-71f1-aeba-d8423ba1d6ed",
        "storage_key": "property/5753165609697280/019f1502-5a14-71f1-aeba-d8423ba1d6ed.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TtRaxNxToYRsWV5J0iS5SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_3f174673c8585290abf7523e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "CentrePort/DFW Airport Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "14470 Statler Blvd, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-6020-7172-9f80-4926153a0392.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6020-7172-9f80-4926153a0392",
        "storage_key": "property/5753165609697280/019f1506-6020-7172-9f80-4926153a0392.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/guide/transit-and-use/rail/rail-station-detail/centreport-dfw-airport-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619245285415004907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centreportdfw-airport-station",
      "poi_latitude": "32.8170102",
      "poi_longitude": "-97.0528488",
      "poi_miles_from_property": "27.6 mi",
      "poi_walking_minutes": "10 hours 7 mins",
      "poi_biking_minutes": "2 hours 43 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-84cb-709b-82f8-5ad3a42cb44f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-84cb-709b-82f8-5ad3a42cb44f",
        "storage_key": "property/5753165609697280/019f1506-84cb-709b-82f8-5ad3a42cb44f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7AqJ-KAToYR6ypjCQK3eBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c6f1e641fbb18e55c885c724",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-6202-740f-9083-4dad56483dc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6202-740f-9083-4dad56483dc5",
        "storage_key": "property/5753165609697280/019f1506-6202-740f-9083-4dad56483dc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "31.1 mi",
      "poi_walking_minutes": "11 hours 29 mins",
      "poi_biking_minutes": "3 hours 13 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-84dd-7130-86c3-46457740aa53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-84dd-7130-86c3-46457740aa53",
        "storage_key": "property/5753165609697280/019f1506-84dd-7130-86c3-46457740aa53.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_e94070089ccb743d04ff7c47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Ridgmar Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "1888 Green Oaks Rd, Fort Worth, TX 76116, USA",
      "poi_short_description": "2-story mall attracting visitors for its well-known department stores, food court & aquarium.",
      "poi_long_description": "2-story mall attracting visitors for its well-known department stores, food court & aquarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-632e-7572-9d2b-6accc183b3bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-632e-7572-9d2b-6accc183b3bc",
        "storage_key": "property/5753165609697280/019f1506-632e-7572-9d2b-6accc183b3bc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ridgmar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2127979923518851799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridgmar-mall",
      "poi_latitude": "32.740738",
      "poi_longitude": "-97.4370442",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-731-6591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo0_yuEtzToYR1wqBRncaiB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_aeef9a98cdfb8634396faf39",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Hulen Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "4800 S Hulen St, Fort Worth, TX 76132, USA",
      "poi_short_description": "Relaxed mall with department stores, fashion chains & a food court, plus open-air restaurants.",
      "poi_long_description": "Relaxed mall with department stores, fashion chains & a food court, plus open-air restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-1996-7756-88cd-4b55228df0bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-1996-7756-88cd-4b55228df0bb",
        "storage_key": "property/5753165609697280/019f1502-1996-7756-88cd-4b55228df0bb.webp",
        "width": 1280,
        "height": 510
      },
      "poi_business_url": "https://www.hulenmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13236024106689965422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hulen-mall",
      "poi_latitude": "32.678639",
      "poi_longitude": "-97.398763",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-294-1205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0WfwT35tToYRbi3DLczNr7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_56bf9e00a424f75c3d3b5a5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "NTTA",
      "poi_type": "Transportation & Transit",
      "poi_address": "4825 Overton Ridge Blvd #304, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-63a3-7302-9abd-78f56fdf1abc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-63a3-7302-9abd-78f56fdf1abc",
        "storage_key": "property/5753165609697280/019f1506-63a3-7302-9abd-78f56fdf1abc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://ntta.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=403298661020329191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ntta",
      "poi_latitude": "32.6760284",
      "poi_longitude": "-97.3998907",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-731-6882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpx__oH5tToYR5-SB1P7NmAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "toll_station"
    },
    {
      "id": "ec_d83b7d443eecb7514c2688b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hospital Southwest Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6100 Harris Pkwy, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-477d-758e-8239-ba9ab0934428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-477d-758e-8239-ba9ab0934428",
        "storage_key": "property/5753165609697280/019f1506-477d-758e-8239-ba9ab0934428.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-southwest-fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=17731957295412397178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hospital-southwest-fort-worth",
      "poi_latitude": "32.6577313",
      "poi_longitude": "-97.4208753",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-433-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f7-714d-b29a-5aa73049b21d",
        "storage_key": "property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2dlv0BtToYResRzVTaRFPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_3ded6da04651a0de857ba40f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Baylor Scott & White Institute for Rehabilitation - Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6601 Harris Pkwy, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-69e5-737a-8ca1-33eb529d8892.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-69e5-737a-8ca1-33eb529d8892",
        "storage_key": "property/5753165609697280/019f1506-69e5-737a-8ca1-33eb529d8892.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bswrehab.com/locations-and-tours/bswir-fort-worth/?ty=xt",
      "poi_directions_map_url": "https://maps.google.com/?cid=12667950952453744565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-institute-for-rehabilitation---fort-worth",
      "poi_latitude": "32.6541773",
      "poi_longitude": "-97.4180374",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-433-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f7-714d-b29a-5aa73049b21d",
        "storage_key": "property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTBT1sSYToYRtacTCUaaza8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_9148cfc5acf13e234b782a14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "LifeCare Hospital of Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6201 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-77da-76b9-a1a3-0481bb1d831e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-77da-76b9-a1a3-0481bb1d831e",
        "storage_key": "property/5753165609697280/019f1506-77da-76b9-a1a3-0481bb1d831e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lifecare-health.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6583763442643134086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lifecare-hospital-of-fort-worth",
      "poi_latitude": "32.6790853",
      "poi_longitude": "-97.421337",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-222-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f7-714d-b29a-5aa73049b21d",
        "storage_key": "property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1aJW19tToYRhmbyA_g5Xls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_965dbf3a41302e9d250c3e2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Regency Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6801 Oakmont Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-6d6e-7388-a446-4571de319b79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6d6e-7388-a446-4571de319b79",
        "storage_key": "property/5753165609697280/019f1506-6d6e-7388-a446-4571de319b79.webp",
        "width": 1062,
        "height": 602
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16214505424914863169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regency-fort-worth",
      "poi_latitude": "32.6622188",
      "poi_longitude": "-97.4141593",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-840-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f7-714d-b29a-5aa73049b21d",
        "storage_key": "property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJUd7WMWptToYRQdSxnMZ-BeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_13e8c62dfd50dc601e227a9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Kindred Hospital Tarrant County - Fort Worth Southwest",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7800 Oakmont Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-6afe-72dc-b7a9-3fb0ff1c9cba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6afe-72dc-b7a9-3fb0ff1c9cba",
        "storage_key": "property/5753165609697280/019f1506-6afe-72dc-b7a9-3fb0ff1c9cba.webp",
        "width": 680,
        "height": 455
      },
      "poi_business_url": "https://www.kindredhospitals.com/locations/texas/tarrant-county-fort-worth-southwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=16927186947357217756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kindred-hospital-tarrant-county---fort-worth-southwest",
      "poi_latitude": "32.665729",
      "poi_longitude": "-97.4239401",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-346-0094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f7-714d-b29a-5aa73049b21d",
        "storage_key": "property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs46e5URtToYR3BPbM9hy6eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_87a64da6b8b9fe463e4bf02f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5300 Overton Ridge Blvd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-2d44-7485-82f0-0b07b3521a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2d44-7485-82f0-0b07b3521a2b",
        "storage_key": "property/5753165609697280/019f1506-2d44-7485-82f0-0b07b3521a2b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/fort-worth-TX-489.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8868950127388496786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "32.677542",
      "poi_longitude": "-97.4087336",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-210-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5995-768b-8efa-f9b2e44cc3c1",
        "storage_key": "property/5753165609697280/019f1502-5995-768b-8efa-f9b2e44cc3c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbzlaUWJtToYRkpOlsSbXFHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_aa522c41ff32fb95412131fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "United States Air Force Plant 4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lockheed Blvd, Fort Worth, TX 76108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cumulis.epa.gov/supercpad/cursites/csitinfo.cfm?id=0603610",
      "poi_directions_map_url": "https://maps.google.com/?cid=16010628610778343053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-plant-4",
      "poi_latitude": "32.7711827",
      "poi_longitude": "-97.4502721",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSVNmIQLToYRjSYmwOQtMd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_4a79261b8fe889f473ea1364",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "American Airlines - Skyview 7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "RWFJ+R6, Transformation Way, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-6ca8-731f-bc1c-e42772f12b25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6ca8-731f-bc1c-e42772f12b25",
        "storage_key": "property/5753165609697280/019f1506-6ca8-731f-bc1c-e42772f12b25.webp",
        "width": 1280,
        "height": 450
      },
      "poi_business_url": "http://www.aa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15492633573707074314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-airlines---skyview-7",
      "poi_latitude": "32.8291621",
      "poi_longitude": "-97.0659943",
      "poi_miles_from_property": "26.6 mi",
      "poi_walking_minutes": "9 hours 44 mins",
      "poi_biking_minutes": "2 hours 33 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 682-278-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaLL45iBToYRCssZ3CbkANc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_da09b7ecbd8951c01aeb8a14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "NAS-JRB Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1510 Chenault Ave, Fort Worth, TX 76127, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1506-6fb1-7177-b623-2b6681005889.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6fb1-7177-b623-2b6681005889",
        "storage_key": "property/5753165609697280/019f1506-6fb1-7177-b623-2b6681005889.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cnic.navy.mil/FORTWORTH/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8435256422815089865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nas-jrb-headquarters",
      "poi_latitude": "32.7734992",
      "poi_longitude": "-97.4234965",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 817-782-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-5999-76af-9cf8-682f90b74928",
        "storage_key": "property/5753165609697280/019f1502-5999-76af-9cf8-682f90b74928.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFQDQYlVzToYRycQ5TwYNEHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_5583ade6bb40a3cc5f566bcf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "poi_name": "Baylor Scott & White All Saints Medical Center - Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1400 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-368b-704f-a000-da493ab50827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-368b-704f-a000-da493ab50827",
        "storage_key": "property/5753165609697280/019f1502-368b-704f-a000-da493ab50827.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/fort-worth?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-8119502",
      "poi_directions_map_url": "https://maps.google.com/?cid=14939051515624993574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-all-saints-medical-center---fort-worth",
      "poi_latitude": "32.7295641",
      "poi_longitude": "-97.3452152",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-926-2544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-59f7-714d-b29a-5aa73049b21d",
        "storage_key": "property/5753165609697280/019f1502-59f7-714d-b29a-5aa73049b21d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8FWXkJtToYRJrMW9jMsUs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    }
  ],
  "office_hours": [
    {
      "id": "custom_8489cbd4-66fc-4d87-b7da-05a07cbc4c68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_10ce7319-2067-4cdf-87e4-f63b59cd06f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8bf16ab9-a65c-40e2-a6a5-b264a5788131",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a5d1fdaf-0856-4b03-897b-2d67eefa74a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_d028fbf9-087d-4f39-94f3-bc3e737e08e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_edf133e8-2c43-44c2-8c87-7d9e332c7211",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_918fb376-6e16-44b3-9b7c-a81efe05e1b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "rating": "5.0",
      "name": "Marie Harris",
      "text": "The staff was awesome I was working with Brittany she’s so nice and did everything to help me get approved to move in and I got approved and I was happy. But life happens and I didn’t move in but I did let her know that when I get back on my feet I’ll come and reapply with them because not only her but her coworkers was helpful when Brittany wasn’t in the office. So keep being great at Laurel Heights",
      "date": "2026-05-07",
      "title": ""
    },
    {
      "id": "custom_69718670-034d-4465-9061-96fc69b12cfb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "rating": "5.0",
      "name": "Mariana Picazzo",
      "text": "I just wanted to leave a quick review to say how much I appreciate the team at this apartment complex. We recently had an unexpected situation on a Sunday where we accidentally got locked out of our apartment, and the staff went above and beyond to help us.\n\nThe manager and Luis were incredibly kind and responsive, the maintenance team came quickly to help us get back inside. It meant so much that they were willing to help even on a Sunday when most places wouldn’t respond so fast.\n\nThank you for being so helpful, professional, and caring toward your residents. Moments like this really show how much you value the people who live here. We truly appreciate the support!",
      "date": "2026-03-10",
      "title": ""
    },
    {
      "id": "custom_f5195b27-2095-480a-979b-f6de419b285b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "rating": "5.0",
      "name": "Jason Stackhouse",
      "text": "Courtney, Brittany, & Ashley have been by far the best people to run an apartment complex that I have come across. They have made my son an I’s move-in seamless and very enjoyable. They are very personable and friendly 10 out of 10 recommend them and Laurel heights apt complex. If we’ve needed maintenance or anything needs to be communicated they are quick to act or notify!",
      "date": "2026-03-27",
      "title": ""
    },
    {
      "id": "custom_0b0276ce-3086-49be-9738-a0cbeb3b2d7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "rating": "5.0",
      "name": "Enrique Soutelo",
      "text": "Daniela es muy especial. Daniella amazing, she’s the new manager and you can tell the office attitude has changed! The staff look way happier, now that they’re not getting yelled at. Amazing! To see everyone smiling! I would recommend leasing there. Good to see a person of\nColor on the office.",
      "date": "2025-11-03",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_2cbae7f3e6674ca09c682e1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f14c4-0de0-7713-a74e-a959aff83188.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-0de0-7713-a74e-a959aff83188",
        "storage_key": "property/5753165609697280/019f14c4-0de0-7713-a74e-a959aff83188.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Laurel Heights at Cityview",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/sqyPeSbllfA"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-a4dd-73fe-84a1-13ccf363251c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "laurel-heights-at-cityview",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280"
    },
    {
      "lead_collector_id": "0198aa45-a543-730f-bff8-a7bc56e02491",
      "lead_source": "FACEBOOK_ADS",
      "name": "laurel-heights-at-cityview",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280"
    },
    {
      "lead_collector_id": "0198aa45-a5a6-75f8-aa5f-d1b23bdd11b4",
      "lead_source": "LANDING_PAGE",
      "name": "laurel-heights-at-cityview",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "luxury-pool-apartments-fort-worth-laurel-heights-693",
      "search_query": "luxury pool apartments in Fort Worth",
      "category": "Amenity",
      "h1_title": "Luxury Pool Apartments in Fort Worth",
      "h2_subtitle": "Experience unparalleled living in Fort Worth with our luxury pool apartments. Dive into relaxation at Laurel Heights at Cityview today!",
      "page_copy": "Discover the hidden gem of luxury pool apartments in Fort Worth at Laurel Heights at Cityview. Our community offers a refreshing escape with a stunning pool, perfect for leisurely swims or relaxing under the sun. Nestled in the vibrant city of Fort Worth, TX, residents enjoy the perfect balance between lavish amenities and cozy living spaces in our stylish one and two-bedroom floor plans.\n\nAt Laurel Heights at Cityview, every detail is crafted to enhance your lifestyle. Beyond the pool, indulge in our fitness center and vibrant clubhouse, or relax on your private patio. Whether you're a pet lover enjoying the dog park or someone who values convenience with our on-site property management, experience the best of apartment living right here. Make Laurel Heights your luxurious retreat in Fort Worth today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Luxury Pool Apartments Fort Worth",
      "seo_description": "Discover luxury pool apartments in Fort Worth at Laurel Heights. Enjoy spacious floor plans and premium amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "dog-park-apartments-tarrant-county-laurel-heights-42",
      "search_query": "dog park apartments Tarrant County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Tarrant County",
      "h2_subtitle": "Explore our dog park apartments in Tarrant County at Laurel Heights. Enjoy convenience and comfort in a pet-friendly community.",
      "page_copy": "For pet lovers seeking dog park apartments in Tarrant County, Laurel Heights at Cityview offers a perfect balance of luxury and pet-friendly amenities. Our community features a well-maintained dog park where your furry friends can play and socialize. Nestled in Fort Worth, TX, enjoy stylish one and two-bedroom apartments with amenities like ceiling fans and private patios.\n\nOur apartment community in Tarrant County is more than just pet-friendly—it's a lifestyle. In addition to the dog park, residents have exclusive access to a fitness center, refreshing pool, and vibrant clubhouse. Located conveniently in Fort Worth, enjoy the harmony of comfort and the convenience of community living at Laurel Heights. Discover the ultimate pet-friendly haven today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Dog Park Apartments Tarrant County",
      "seo_description": "Discover dog park apartments in Tarrant County at Laurel Heights. Pet-friendly living with fantastic amenities. Book your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-76132-laurel-heights-359",
      "search_query": "in unit laundry apartments 76132",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apartments in 76132",
      "h2_subtitle": "Find convenience with in unit laundry apartments in the 76132 area. Explore Laurel Heights at Cityview for comfortable living.",
      "page_copy": "Experience the convenience of in unit laundry apartments in 76132 at Laurel Heights at Cityview. Our Fort Worth community offers residents the perfect blend of style and practicality with elegant one and two-bedroom floor plans. Enjoy the luxury of handling laundry from the comfort of your own home, allowing more time for relaxation and leisure.\n\nLocated in the heart of Fort Worth, TX, within the lively area of 76132, Laurel Heights complements in-unit amenities with a sparkling pool, modern fitness center, and inviting clubhouse. With features like ceiling fans and private patios, you can enjoy a comfortable living environment tailored to your needs. Discover the ease and comfort of maintaining your lifestyle with our in-unit laundry system today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | In Unit Laundry Apartments 76132",
      "seo_description": "Discover in unit laundry apartments in the 76132 area at Laurel Heights. Enjoy stylish living with convenient amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-cityview-laurel-heights-185",
      "search_query": "air conditioned apartments near Cityview",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Cityview",
      "h2_subtitle": "Stay comfortable year-round in our air conditioned apartments near Cityview. Discover Laurel Heights at Cityview's luxurious offerings today.",
      "page_copy": "Stay cool and comfortable in our air conditioned apartments near Cityview. Laurel Heights at Cityview in Fort Worth, TX, offers residents the ultimate comfort with modern air conditioning in every unit. Choose from our spacious one and two-bedroom floor plans and enjoy a host of luxurious amenities designed to enhance your lifestyle near Cityview.\n\nBeyond climate-controlled interiors, our community features a refreshing pool, modern fitness center, and interactive clubhouse, ensuring entertainment and leisure options are always at hand. With additional amenities like ceiling fans and private patios, Laurel Heights provides an all-inclusive living experience. Embrace comfort and style in our air conditioned apartments near Cityview today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Air Conditioned Apartments Cityview",
      "seo_description": "Explore air conditioned apartments near Cityview at Laurel Heights. Enjoy year-round comfort and luxury amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-apartments-fort-worth-laurel-heights-634",
      "search_query": "dishwasher equipped apartments Fort Worth TX",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments in Fort Worth, TX",
      "h2_subtitle": "Discover our dishwasher equipped apartments in Fort Worth, TX. Laurel Heights at Cityview offers modern living comforts.",
      "page_copy": "Experience the convenience of kitchen efficiency in our dishwasher equipped apartments in Fort Worth, TX. Laurel Heights at Cityview provides an ideal blend of luxury and practicality. Our spacious one and two-bedroom apartments come with fully-equipped kitchens, including dishwashers, making everyday tasks more manageable and freeing up your time.\n\nLocated in the vibrant Fort Worth community, Laurel Heights offers more than just modern kitchen amenities. Enjoy access to a well-maintained pool, fitness center, and lively clubhouse. With additional features like ceiling fans, private patios, and a dedicated on-site property manager, we provide a complete lifestyle experience. Discover comfort and ease at our dishwasher equipped apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Dishwasher Equipped Apartments Fort Worth",
      "seo_description": "Discover dishwasher equipped apartments in Fort Worth, TX at Laurel Heights. Enjoy modern living with convenient amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-fort-worth-tx-laurel-heights-971",
      "search_query": "one bedroom apartments fort worth tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Fort Worth, TX",
      "h2_subtitle": "Discover the comfort of one bedroom apartments in Fort Worth, TX. Explore living at Laurel Heights at Cityview.",
      "page_copy": "Find the perfect blend of style and convenience with our one bedroom apartments in Fort Worth, TX, at Laurel Heights at Cityview. These thoughtfully designed spaces offer a seamless blend of comfort and modern amenities, ensuring that all your lifestyle needs are met. Whether you’re looking for a serene retreat or a vibrant community experience, our one bedroom options provide the best of both worlds.\n\nLocated in a bustling Fort Worth neighborhood, our community boasts luxurious amenities such as a sparkling pool, modern fitness center, and welcoming clubhouse. With features like ceiling fans, patios, and the assurance of a dedicated property manager on site, you’ll find all you need and more. Experience comfortable living in style at Laurel Heights today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | One Bedroom Apartments Fort Worth, TX",
      "seo_description": "Explore one bedroom apartments in Fort Worth, TX at Laurel Heights. Comfortable living with luxury amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-tarrant-county-laurel-heights-98",
      "search_query": "two bedroom apartments tarrant county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tarrant County",
      "h2_subtitle": "Explore the spacious two bedroom apartments in Tarrant County at Laurel Heights. Enjoy luxury living in Fort Worth, TX.",
      "page_copy": "Discover the ultimate in spacious living with our two bedroom apartments in Tarrant County at Laurel Heights at Cityview. Perfect for families or those in need of extra space, our thoughtfully designed floor plans offer comfort and luxury in the heart of Fort Worth. Each apartment features modern amenities, making it the ideal choice for those seeking a premium lifestyle.\n\nOur community complements your living experience with luxurious amenities, including a refreshing pool, state-of-the-art fitness center, and vibrant clubhouse. Enhance your quality of life with additional features such as ceiling fans, private patios, and a proactive property management team on site. Embrace a sophisticated lifestyle in our two bedroom apartments in Tarrant County at Laurel Heights.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Two Bedroom Apartments Tarrant County",
      "seo_description": "Discover two bedroom apartments in Tarrant County at Laurel Heights. Enjoy spacious living with top-notch amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "apartments-near-tcu-fort-worth-laurel-heights-399",
      "search_query": "apartments near TCU Fort Worth",
      "category": "School",
      "h1_title": "Apartments Near TCU in Fort Worth",
      "h2_subtitle": "Explore apartments near TCU in Fort Worth at Laurel Heights. Enjoy proximity and luxury living.",
      "page_copy": "If you're seeking apartments near TCU in Fort Worth, look no further than Laurel Heights at Cityview. Our community offers a convenient location just a short drive from Texas Christian University, perfect for students, faculty, or anyone who wants easy access to the campus. Enjoy the balance of quality education and luxury living in our thoughtfully designed apartments.\n\nLaurel Heights doesn't just offer proximity to TCU; it also boasts luxurious amenities ideal for a modern lifestyle. With a refreshing pool, state-of-the-art fitness center, and a vibrant clubhouse, relaxation and recreation are just steps from your door. Choose from spacious one or two-bedroom floor plans equipped with ceiling fans and private patios, all supported by an attentive on-site property management team. Embrace both comfort and convenience today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Apartments Near TCU Fort Worth",
      "seo_description": "Find apartments near TCU in Fort Worth at Laurel Heights. Luxury living with easy campus access. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "apartments-near-texas-christian-university-76132-laurel-heights-911",
      "search_query": "apartments near Texas Christian University 76132",
      "category": "School",
      "h1_title": "Apartments Near Texas Christian University 76132",
      "h2_subtitle": "Discover stylish apartments near Texas Christian University in the 76132 area at Laurel Heights. Enjoy convenience and modern amenities.",
      "page_copy": "For those searching for apartments near Texas Christian University in the 76132 area, Laurel Heights at Cityview offers an ideal living solution. Situated in Fort Worth, our community provides easy access to TCU, making it perfect for students, faculty, and staff who wish to stay connected to the campus while enjoying a comfortable lifestyle.\n\nLaurel Heights combines convenience with luxury, featuring a range of amenities such as a refreshing pool, a modern fitness center, and a vibrant clubhouse. Whether you choose a one or two-bedroom layout, you'll benefit from contemporary features like ceiling fans and private patios. Additionally, our dedicated on-site property management team ensures a smooth and stress-free living experience. Make Laurel Heights your new home and enjoy unparalleled convenience in the 76132 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Apartments Near Texas Christian University 76132",
      "seo_description": "Explore apartments near Texas Christian University in 76132 at Laurel Heights. Luxurious living with campus accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "apartments-close-to-unt-health-science-center-laurel-heights-712",
      "search_query": "apartments close to UNT Health Science Center",
      "category": "School",
      "h1_title": "Apartments Close to UNT Health Science Center",
      "h2_subtitle": "Find the perfect apartments close to UNT Health Science Center at Laurel Heights. Enjoy proximity and comfort in Fort Worth.",
      "page_copy": "Looking for apartments close to UNT Health Science Center? Laurel Heights at Cityview in Fort Worth offers the perfect combination of convenience and luxury. With our prime location, you'll have quick and easy access to the UNT Health Science Center, making it ideal for students and professionals alike.\n\nOur community is designed to enhance your living experience with top-tier amenities such as a sparkling pool, fully-equipped fitness center, and a vibrant clubhouse. Choose from spacious one or two-bedroom apartments that include modern conveniences like ceiling fans and private patios. Plus, our attentive property management team is always on site to ensure your needs are met. Experience the best of both worlds—convenience and upscale living—at Laurel Heights.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Apartments Close to UNT Health Science Center",
      "seo_description": "Discover apartments close to UNT Health Science Center at Laurel Heights. Enjoy luxury living with easy access. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "apartments-near-tcu-mary-couts-burnett-library-laurel-heights-638",
      "search_query": "apartments near TCU Mary Couts Burnett Library Fort Worth",
      "category": "School",
      "h1_title": "Apartments Near TCU Mary Couts Burnett Library",
      "h2_subtitle": "Explore apartments near TCU Mary Couts Burnett Library in Fort Worth at Laurel Heights. Enjoy seamless access and enhanced living.",
      "page_copy": "Searching for apartments near TCU Mary Couts Burnett Library in Fort Worth? Laurel Heights at Cityview offers the perfect residence for those seeking close proximity to this notable academic resource. Situated just a short drive from the campus, our community provides an ideal living environment for TCU students and staff alike.\n\nAt Laurel Heights, you won't just benefit from being near the library; you'll also experience top-notch amenities that enrich your lifestyle. Relax by the pool, stay fit at our modern fitness center, or unwind with friends in the clubhouse. Our spacious one and two-bedroom apartments come with features like ceiling fans and private patios, designed for your comfort. Enjoy the ease of access along with luxurious living at Laurel Heights, right near TCU’s Mary Couts Burnett Library.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Apartments Near TCU Mary Couts Burnett Library",
      "seo_description": "Find apartments near TCU Mary Couts Burnett Library in Fort Worth at Laurel Heights. Luxury living with library access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "apartments-close-to-lil-goldman-early-learning-center-laurel-heights-364",
      "search_query": "apartments close to Lil Goldman Early Learning Center Fort Worth",
      "category": "School",
      "h1_title": "Apartments Close to Lil Goldman Early Learning Center",
      "h2_subtitle": "Discover comfortable apartments close to Lil Goldman Early Learning Center in Fort Worth at Laurel Heights. Enjoy family-friendly living.",
      "page_copy": "If you're looking for apartments close to Lil Goldman Early Learning Center in Fort Worth, Laurel Heights at Cityview offers an excellent option for families who value both convenience and luxury. Located just a short drive from the center, Laurel Heights provides an ideal living environment for families with young children.\n\nOur community is designed with families in mind, offering spacious one and two-bedroom apartments equipped with modern amenities like ceiling fans and private patios. Additionally, you'll enjoy community features such as a sparkling pool and a welcoming clubhouse. With our dedicated on-site property management team, you can rest assured that all your needs are taken care of. Experience family-friendly comfort and easy access to local education centers at Laurel Heights.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Apartments Close to Lil Goldman Early Learning Center",
      "seo_description": "Explore family-friendly apartments close to Lil Goldman Early Learning Center in Fort Worth at Laurel Heights. Convenient and luxurious living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "apartments-near-fort-worth-academy-tarrant-county-laurel-heights-758",
      "search_query": "apartments near Fort Worth Academy Tarrant County",
      "category": "School",
      "h1_title": "Apartments Near Fort Worth Academy Tarrant County",
      "h2_subtitle": "Explore premium apartments near Fort Worth Academy in Tarrant County at Laurel Heights. Enjoy convenient and upscale living.",
      "page_copy": "For those seeking apartments near Fort Worth Academy in Tarrant County, Laurel Heights at Cityview offers an unparalleled living experience. Conveniently located, our community provides easy access to the academy, making it perfect for families and staff looking for nearby accommodations.\n\nLaurel Heights combines proximity with luxury, offering spacious one and two-bedroom apartments that cater to your lifestyle needs. Our amenities, including a refreshing pool, modern fitness center, and welcoming clubhouse, ensure that you have everything you need within reach. With on-site property management, residents enjoy personalized service and a peaceful environment. Choose Laurel Heights for a balanced blend of convenience and comfort near Fort Worth Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Apartments Near Fort Worth Academy Tarrant County",
      "seo_description": "Discover luxurious apartments near Fort Worth Academy in Tarrant County at Laurel Heights. Enjoy convenience and superior amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "apartments-near-southwest-christian-school-laurel-heights-48",
      "search_query": "apartments near Southwest Christian School Fort Worth",
      "category": "School",
      "h1_title": "Apartments Near Southwest Christian School, Fort Worth",
      "h2_subtitle": "Discover ideal apartments near Southwest Christian School in Fort Worth at Laurel Heights. Experience convenient school access and modern living.",
      "page_copy": "Looking for apartments near Southwest Christian School in Fort Worth? Laurel Heights at Cityview is the perfect place for families who value proximity to quality education. Located just a short drive away, our community offers an enticing blend of convenience and modern comfort.\n\nResidents of Laurel Heights enjoy spacious one and two-bedroom layouts designed with family needs in mind. Our luxurious amenities, including a sparkling pool and fitness center, provide relaxation and recreation opportunities. With our efficient on-site property management team, you can experience worry-free living. Choose Laurel Heights for a welcoming community that's perfectly situated near Southwest Christian School, offering both accessibility and exemplary living standards.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Apartments Near Southwest Christian School Fort Worth",
      "seo_description": "Find convenient and modern apartments near Southwest Christian School in Fort Worth at Laurel Heights. Enjoy family-friendly living and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5753165609697280",
      "source": "custom",
      "page_item_url": "apartments-close-to-sue-crouch-intermediate-school-laurel-heights-664",
      "search_query": "apartments close to Sue Crouch Intermediate School Fort Worth",
      "category": "School",
      "h1_title": "Apartments Close to Sue Crouch Intermediate School, Fort Worth",
      "h2_subtitle": "Find welcoming apartments close to Sue Crouch Intermediate School in Fort Worth at Laurel Heights. Enjoy nearby school access and comfortable living.",
      "page_copy": "For those in search of apartments close to Sue Crouch Intermediate School in Fort Worth, Laurel Heights at Cityview offers a superb choice. Strategically located, our community makes it simple for families to commute effortlessly to the school, balancing convenience with a superb living environment.\n\nLaurel Heights features spacious one and two-bedroom apartments ideal for families, complemented by outstanding amenities like a vibrant clubhouse and a serene pool. Our fitness center and dog park ensure that every member of the family has a place to thrive. With professional management on site, you'll enjoy a seamless living experience. Select Laurel Heights for its proximity to Sue Crouch Intermediate School and take advantage of a welcoming, neighborly atmosphere coupled with modern living conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
      "featured_image_media": {
        "alt_text": "Bright and airy fitness center with cardio machines and weight equipment.",
        "public_id": "019f6c0f-87ed-70e0-91fa-198a443f34ac",
        "storage_key": "property/5753165609697280/019f6c0f-87ed-70e0-91fa-198a443f34ac.webp",
        "width": 1233,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laurel Heights | Apartments Close to Sue Crouch Intermediate School Fort Worth",
      "seo_description": "Explore family-friendly apartments close to Sue Crouch Intermediate School in Fort Worth at Laurel Heights. Enjoy convenient, comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2171"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471509"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a36\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a36\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4520334"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NRLTX8S"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://laurelheig.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443872084"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/z40vl15nple"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/914ab7b6-e9d0-47ad-bdca-2ac06e935b25"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-760-7951"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im5EZFdNYUViblNIWnNES0pNdllEZlE9PSIsInZhbHVlIjoiem5LV3dScGhmSUxYM1NyWnJKeDZhQT09IiwibWFjIjoiMzBmMjBlMDVlMzY5NTc5MDIxZDIxZTgzZTljZTE5ZWVlOGNmOWVkOTQ3MDU4NWM1NjNmYzkzZDM2YmIzODgzMCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2171",
  "custom_repli_id": "2376471509",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a36\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a36\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4520334",
  "custom_google_gtm_id": "GTM-NRLTX8S",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "none",
  "custom_betterbot_script": "<script src=\"https://laurelheig.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443872084",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/z40vl15nple",
  "custom_self_guided_tour_url": "https://selftournow.com/property/914ab7b6-e9d0-47ad-bdca-2ac06e935b25",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-760-7951",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im5EZFdNYUViblNIWnNES0pNdllEZlE9PSIsInZhbHVlIjoiem5LV3dScGhmSUxYM1NyWnJKeDZhQT09IiwibWFjIjoiMzBmMjBlMDVlMzY5NTc5MDIxZDIxZTgzZTljZTE5ZWVlOGNmOWVkOTQ3MDU4NWM1NjNmYzkzZDM2YmIzODgzMCJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:38:32.837Z';
